// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  approved_for_subscription_purchase: 'Approved for subscription purchase',
  // Funnel translations
  Views: 'Views',
  'Unique Visitors': 'Visitors',
  'Ordered Tickets': 'Ordered Tickets',
  'Approved Tickets': 'Approved Tickets',
  'Refunded Tickets': 'Refunded Tickets',
  'Share link': 'Share link',
  'Purchases': 'Purchases',
  currency: {
    name: 'USD',
    symbol: '$',
    format: '${{value}}',
  },
  charge_type: {
    "manual-charge": "Manual charge",
    "top-up": "Top-up",
    "subscription": "Subscription",
    "default": "Default"
  },
  powered_by: 'Built with love by',
  company_code: 'Company Code:',
  whatsapp_support: 'Text us on WhatsApp',
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  'Birthday': 'Birthday',
  'First name': 'First name',
  'Last name': 'Last name',
  'Email': 'Email',
  'Phone': 'Phone',
  'Gender': 'Gender',
  'Link to social network such as Facebook, Instagram, etc.': 'Link to social network such as Facebook, Instagram, etc.',
  "event-type": "Event type",
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  edit_profile: 'Edit Profile',
  basic_information: 'Basic Information',
  additional_information: 'Additional Information',
  image_upload: {
    allowed_formats: 'Allowed *.jpeg, *.jpg, *.png, *.gif',
    max_size: 'max size of {{size}}',
  },
  avatar_editor: {
    title: 'Move & Scale',
    save: 'Save photo',
    cancel: 'Cancel',
    reposition_aria: 'Drag to reposition your photo',
    zoom_aria: 'Zoom',
  },
  show_more: 'Show More',
  show_less: 'Show Less',
  show_all: 'Show All',
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: {
    activate: 'Activate',
    yes: 'Yes',
    no: 'No',
    enabled: 'Enabled',
    disabled: 'Disabled',
    open: 'Open',
    closed: 'Closed',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    actions: 'Actions',
    minutes: 'minutes',
    from: 'From',
    to: 'To',
    date_range_income_only: 'The date range filters income only. Ticket and buyer totals are shown for all time.',
    event_revenues: 'Event Revenues',
    seller_revenues: 'Seller Revenues',
    subscription_revenues: 'Subscription Revenues',
    welcome_male: 'Welcome',
    welcome_female: 'Welcome',
    welcome_description: 'Here you can see a general overview of system data',
    total_customers_this_year: 'Total customers this year',
    total_revenues_this_year: 'Total revenues this year',
    total_events_this_year: 'Total events this year',
    monthly_revenues: 'Monthly revenues',
    recent_orders: 'Recent orders',
    order_number: 'Order number',
    event_name: 'Event name',
    price: 'Price',
    status: 'Status',
    date: 'Date',
    recent_customers: 'Recent customers',
    today: 'Today',
    this_week: 'This week',
    since_month_start: 'Since month start',
    since_quarter_start: 'Since quarter start',
    since_year_start: 'Since year start',
    compared_to_year_average: 'Compared to year average',
    new_subscribers: 'New subscribers',
    waiting_for_approval: 'Waiting for approval',
    order_rejected: 'Order rejected',
    order_approved: 'Order approved',
    order_cancelled: 'Order cancelled',
    order_refunded: 'Order refunded',
    churned_subscribers: 'Churned subscribers',
  },
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  coming_events: `Coming Events`,
  "all-events": 'Upcoming events',
  seller_public: {
    no_subscriptions: 'No subscriptions available at the moment',
    no_entry_passes: 'No entry passes available at the moment',
    no_events: 'No events',
    thank_you_for_purchase: 'Thank you for your purchase',
    how_to_use_subscription: 'How to use the subscription?',
    subscription_usage_instructions: 'Simply go to the events page, choose an event, order tickets, and the price will be automatically updated according to the subscription you purchased',
    book_tickets_with_subscription: 'Book tickets using subscription',
    continue: 'Continue',
    invalid_phone: 'Invalid phone number',
    verification_sent: 'We just sent you a verification code to your phone',
    enter_verification_code: 'Please enter the code you received',
    code_sent_to_email: 'We just sent a verification code to your email {{email}}',
    code_sent_to_whatsapp: 'We sent it to your WhatsApp',
    verification: 'Verification',
    didnt_receive_code: 'Didn\'t receive a code?',
    check_details_and_try_again: 'Check the details and try again',
    verification_not_found: 'Verification code not found, please request a new code',
    invalid_verification_code: 'Invalid verification code',
    personal_details: 'Personal details',
    payment: 'Payment',
    login: 'Login',
    tickets: 'Tickets',
    tickets_count: '{{num}} tickets',
    time_slots: 'Time Slots',
    upcoming_events: 'Upcoming events',

    get_one_time_code: 'Get a one-time access code',
    enter_phone_number: 'Enter your phone number',
    enter_whatsapp_number: 'Enter your WhatsApp phone number',
    no_phone_number: 'I don\'t have a local phone number',
    send_login_code: 'Send login code',
    signup: 'Sign up',
    fill_details: 'Please fill in the following details',
    code_sent_again: 'Code sent again',
    try_again: 'Try again',
    phone_not_found: 'Phone number not found, please check the number and try again',
    error_occurred: 'An error occurred, please try again later',
    wrong_verification_code: 'Wrong verification code, please check the code and try again',
    phone_already_exists: 'Phone number already exists in the system',
    you_are_connected: 'You are connected',
    signup_here: 'Sign up here',
    ui_customization: {
      font: {
        label: 'Custom Font',
        helper: 'Enter the font family name (e.g., "Roboto", "Open Sans")',
        placeholder: 'Enter font URL or upload font file'
      },
      fontUrl: {
        label: 'Font File',
        helper: "We recommend using .woff OR .woff2 formats",
        placeholder: 'Enter font URL or upload font file'
      },
      titleFont: {
        label: 'Title Font',
        helper: 'Enter the font family name for titles (e.g., "Roboto Slab", "Montserrat")',
        placeholder: 'Enter title font family name'
      },
      titleFontUrl: {
        label: 'Title Font File',
        helper: 'We recommend using .woff OR .woff2 formats for title font',
        placeholder: 'Enter title font URL or upload font file'
      },
      colors: {
        primary: 'Primary color',
        background_overlay: 'Background overlay'
      },
      loader: {
        label: 'Loader type',
        types: {
          default: 'Default',
          linear: 'Linear',
          circular: 'Circular'
        }
      }
    }
  },
  got_an_account: 'Got an account?',
  login_here: 'Login here',
  press_here: 'Press here',
  to_my_account: 'To my account',
  to_events: 'To events',
  dont_have_an_account: 'Don\'t have an account?',
  add_comment: 'Add comment',
  edit_comment: 'Edit comment',
  book_now: 'Book now',
  buyer_details_section_title: 'Buyer details (for invoice / receipt)',
  buyer_details_section_subtitle: 'The invoice / receipt will be issued to the buyer name entered here',
  buyer_details_name: 'Buyer name (for invoice / receipt)',
  buyer_name_required: 'Buyer name is required',
  buyer_details_email: 'Email for invoice / receipt',
  buyer_details_business_code: 'Business / VAT ID',
  location: 'Location',
  excel_file: 'Excel file',
  start_hour: 'Start hour',
  comment_updated_success: 'Comment updated successfully',
  save: 'Save',
  hi: 'Hi',
  type: 'Type',
  event: 'Event',
  url: 'URL',
  link: 'Link',
  default: 'Default',
  html: 'HTML',
  cancel: 'Cancel',
  pdf: 'PDF',
  start_date: 'Start date',
  end_date: 'End date',
  logout: 'Logout',
  not_logged_in: 'You are not logged in',
  'entry-pass': 'Entry pass',
  'user-created': 'User created',
  'season-ticket-entry-pass': 'Season ticket entry pass',
  'season-ticket': 'Season ticket',
  documents: {
    id_card: 'ID Card',
    bank_account: 'Cancelled check or bank account management confirmation',
    business_certificate: 'Business registration certificate for exempt dealer/authorized dealer/Ltd company/non-profit',
    update: 'Update'
  },
  season_ticket: {
    title: 'Season Ticket',
    customer_club: 'Customer Club',
    letters_only: 'English or Hebrew letters only, no symbols',
    unlimited_entries: 'To allow unlimited punches, enter 0 or leave empty',
    discount_will_appear_after_choosing_tickets: 'The membership discount will appear later after selecting tickets',
    status: 'Subscription Status',
    subscription_notes: 'Subscription Notes',
    subscription_end_of_month_notice: "The monthly charge for subscriptions purchased after the 28th of the month will be made on the first day of the following month.",
    discount: {
      created_successfully: 'Discount created successfully!',
      updated_successfully: 'Discount updated successfully!'
    },
    entry_pass: {
      title: 'Entry Pass',
      usage: 'Used {{0}} out of {{1}}',
      available_entries: 'Entries available for this event',
      max_available_entries: 'Maximum entries per event',
      total_tickets_allowed: 'Total entries allowed',
      no_entries_left: 'No entries left for this event'
    },
    code: 'Subscription Code',
    table: {
      type: 'Type',
      name: 'Name',
      status: 'Status',
      subscription_type: 'Subscription Type',
      transactions_allowed: 'Transactions Allowed',
      price: 'Price',
      transactions_used: 'Transactions Used',
      iterations_completed: 'Iterations Completed',
      iterations: 'Iterations',
      payment_date: 'Payment Date',
      next_date: 'Next Date',
      start_date: 'Start Date',
      created_date: 'Created Date',
      hrc: 'Code',
      create_subscription: 'Create Subscription',
      create_entry_pass: 'Create Entry Pass',
      title: 'Subscriptions',
      payment_type: 'Payment Type',
      payment_limit: 'Payment Limit',
      event_limit: 'Event Limit',
      actions: 'Actions',
      code: 'Code'
    },
    dialog: {
      click_to_add_free: 'Click to add free',
      edit_title: 'Edit subscription',
      create_title: 'Create subscription',
      create_entry_pass_title: 'Create entry pass',
      name: 'Name',
      event_limit: 'Event limit',
      event_limit_helper: 'Enter 0 for unlimited events',
      price: 'Price',
      payment_type: 'Payment type',
      payment_types: {
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
        one_time: 'One-time'
      },
      payment_limit: 'Payment limit',
      unlimited: 'Unlimited',
      show_in_seller_page: 'Show in seller page',
      start_date: 'Start date',
      description: 'Description',
      submit: 'Submit',
      name_exists: 'Name already exists',
      updated_successfully: 'Updated successfully',
      created_successfully: 'Created successfully',
      unlimited_purchases: 'Unlimited purchases',
      edit_status: 'Update subscription status',
      status_description: {
        paused: 'Pause charges',
        cancelled: 'Final cancellation',
        active: 'Activate charges'
      },
      select_season_ticket: 'Select season ticket',
      add_to_customer: 'Add to customer',
      free_subscription: 'Free subscription',
      proceed_to_payment: 'Proceed to payment',
      cannot_resume_not_paused: 'Can only resume from paused subscription',
      cannot_change_cancelled: 'Cannot change cancelled subscription',
      select_price: 'Please select a price',
      email_required: 'Customer email is required to create a subscription. Please update the customer profile first.',
      end_user_season_ticket_already_in_the_same_status: 'End user season ticket already in the same status',
      max_installments: 'Max installments',
      max_installments_note: 'Max installments buyers can split their payment into (PayMe only)',
      installments_exceed_price: 'Max installments ({{installments}}) exceeds the price ({{price}}). Payme requires each installment to be at least 1 unit of currency.',
      installments_exceed_min_tier_price: 'Max installments ({{installments}}) exceeds the lowest tier price ({{price}}). Payme requires each installment to be at least 1 unit of currency.',
      select_payment_method: 'Payment Method',
      payment_method_credit_card: 'Credit Card',
      payment_method_check: 'Check',
      payment_method_bank_transfer: 'Bank Transfer',
      payment_method_barter: 'Barter',
      banks: {
        9: 'Postal Bank',
        10: 'Bank Leumi',
        11: 'Discount Bank',
        12: 'Bank Hapoalim',
        13: 'Bank Igud (Union Bank)',
        14: 'Bank Otsar Ha-Hayal',
        17: 'Mercantile Discount Bank',
        20: 'Mizrahi-Tefahot Bank',
        23: 'HSBC',
        31: 'First International Bank (FIBI)',
        46: 'Massad Bank',
        52: 'Poalei Agudat Israel Bank',
        54: 'Jerusalem Bank',
        65: 'Arab Israel Bank',
      },
      check_bank: 'Bank',
      check_branch: 'Branch',
      check_account: 'Account',
      check_number: 'Check Number',
      check_date: 'Check Date',
      bank_transfer_account: 'Deposit Account',
      bank_transfer_date: 'Transfer Date',
      barter_comment: 'Invoice Comment',
      field_required: 'This field is required',
      field_numeric: 'Numbers only',
      submit_subscription: 'Add Subscription',
    },
    billing_history: {
      open: 'View billing history',
      dialog_title: 'Billing history — {{name}}',
      pre_tracking_banner_one: '1 earlier iteration was billed before tracking was enabled. Refund it via the Payme dashboard.',
      pre_tracking_banner_other: '{{count}} earlier iterations were billed before tracking was enabled. Refund them via the Payme dashboard.',
      no_iterations: 'No iterations billed yet.',
      fetch_error: 'Failed to load billing history',
      retry: 'Retry',
      payment_method_cash: 'Cash',
      payment_method_pos: 'POS',
      table: {
        iteration: '#',
        date: 'Date',
        amount: 'Amount',
        payment_method: 'Payment method',
        card: 'Card',
        sale_code: 'Sale code',
        invoice: 'Invoice',
        status: 'Status',
        refunded: 'Refunded',
        actions: 'Actions'
      },
      status: {
        none: '—',
        partial: 'Partially refunded',
        full: 'Refunded'
      },
      row: {
        refund_button: 'Refund',
        refunds_header: 'Refund',
        refund_reason: 'Reason'
      },
      refund: {
        title: 'Refund iteration #{{iteration}}',
        amount_label: 'Refund amount',
        amount_helper: 'Max: {{max}}',
        reason_label: 'Reason (optional)',
        warning: 'This action cannot be undone. The subscription will continue to bill on schedule.',
        submit: 'Refund',
        success: 'Iteration refunded successfully',
        invalid_amount: 'Amount must be greater than 0 and up to {{max}}'
      }
    },
    types: {
      entry_pass: 'Entry Pass',
    },
    cannot_change_cancelled: 'Cannot change cancelled subscription',
  },
  segments: {
    manual_selection: 'Manual selection of customers for segment',
    event_auto_add: 'System will automatically add all customers who purchased a ticket for the event',
    season_ticket_auto_add: 'System will automatically add all subscribed customers',
    entry_pass_auto_add: 'System will automatically add all customers who purchased an entry pass',
    activity_auto_add: 'System will automatically add all customers who performed a specific activity',
    event_type_auto_add: 'System will automatically add all customers who attended a specific event type',
    add_to_segment: 'Add to segment',
    remove_from_segment: 'Remove from segment',
    status: {
      active: 'Active',
      paused: 'Paused',
      cancelled: 'Cancelled',
      cancel_at_period_end: 'Cancel next payment cycle',
      initial: 'Initial'
    },
    required_field: 'Required field',
    short_url: 'Short URL',
    sync_message: 'To ensure your segment contains the most up-to-date information, click "Sync Segments"',
    sync_explanation: {
      what_is_it: 'What does it mean?',
      update_list: 'The sync operation updates the list of people in the segment according to the conditions you defined.',
      example: 'For example, if you defined a segment called "Monthly Subscription". The segment is defined to include all customers who purchased a subscription. Each time you click "Sync Segments", the system will check the customer list and add everyone who purchased a subscription up to the sync moment to the "Monthly Subscription" segment.',
      always_updated: 'Syncing segments ensures that the information in the segment is always up to date.'
    },
    create: 'Create',
    created_success: 'New segment created successfully!',
    updated_success: 'Segment updated successfully!',
    handler_exists: 'This short URL already exists',
    new_segment: 'New segment',
    edit_segment: 'Edit segment',
    create_new: 'Create new segment',
    assign_customers: 'Assign customers to segment',
    customers_removed: 'Customers removed from segment successfully',
    customers_added: 'Customers added to segment successfully',
    manual_sync_error: 'Cannot sync manual segments',
    sync_success: 'Segment sync completed successfully'
  },
  end_user: {
    dynamic_fields: 'Additional information',
    dynamic: {
      occupation: 'Occupation',
      referral: 'Referral',
    },
    created_success: 'Customer created successfully!',
    add_new: 'Add new customer',
    customer_page: 'Customer page',
    search: 'Search by name, email, phone...',
    search_crm_events: 'Search by name, description, action...',
    search_orders: 'Search by order #, event, production...',
    search_charges: 'Search by code, description, amount...',
    export: {
      index: '#',
      name: 'Customer name',
      email: 'Email',
      phone: 'Phone number',
      birth_date: 'Birth date',
      social_link: 'Social link',
      download_data: 'Download data',
      download_selected: 'Download selected customers only',
      download_all: 'Download all customers',
      customer_list: 'Customer list'
    },
    import: {
      button: 'Import Excel',
      title: 'Import Customers',
      step_upload: 'Upload File',
      step_mapping: 'Map Columns',
      step_segment: 'Segment Name',
      step_progress: 'Progress',
      supported_formats: 'Supported formats: Excel (.xlsx, .xls) and CSV (.csv)',
      total_rows: 'Total rows found',
      map_columns: 'Map Excel columns to customer fields',
      excel_column: 'Excel Column',
      sample_data: 'Sample Data',
      map_to: 'Map To',
      skip: 'Skip this column',
      phone_required: 'Phone field mapping is required',
      segment_name_required: 'Segment name is required',
      segment_name_label: 'Enter a name for the new segment',
      segment_name_placeholder: 'e.g., January 2025 Import',
      segment_info: 'All imported customers will be added to this segment',
      default_country_code_label: 'Default Country Code',
      default_country_code_info: 'This code will be added to phone numbers that don\'t have a country code',
      starting: 'Starting import...',
      processing: 'Processing...',
      completed: 'Import completed!',
      failed: 'Import failed',
      created: 'Created',
      skipped: 'Skipped',
      skipped_info: 'Rows are skipped when required data (first name, last name, or phone) is missing, or when the phone number already exists',
      errors: 'Errors',
      errors_found: 'Errors Found',
      errors_count: '{{count}} rows had errors',
      summary_title: 'Import Summary',
      summary_skipped_errors: 'Skipped {{skipped}} rows and found {{errors}} errors',
      click_to_download: 'Click to download as CSV',
      rows_processed: 'rows processed',
      success: 'Customers imported successfully!',
      back: 'Back',
      next: 'Next',
      start: 'Start Import',
      close: 'Close',
      // Job recovery and cancel
      importing: 'Importing...',
      cancel: 'Cancel Import',
      cancelled: 'Import cancelled',
      cancelled_title: 'Import Cancelled',
      cancel_failed: 'Failed to cancel import',
      // Format info
      format_info_title: 'File format requirements',
      supported_formats_label: 'Supported formats',
      file_requirements: 'Requirements',
      req_headers: 'First row must contain column headers',
      req_phone: 'Phone column is required for each customer',
      req_data: 'File must contain at least one data row',
      req_separate_names: 'First name and last name must be in separate columns',
      // Error messages
      error_no_headers: 'No column headers found',
      error_no_headers_desc: 'The file appears to be missing column headers in the first row.',
      error_no_headers_fix: 'Add a header row with column names like "First Name", "Phone", "Email"',
      error_empty_file: 'Empty file',
      error_empty_file_desc: 'The uploaded file is empty or could not be read.',
      error_empty_file_fix: 'Make sure the file contains data and try uploading again',
      error_invalid_format: 'Invalid file format',
      error_invalid_format_desc: 'The file could not be parsed. It may be corrupted or in an unsupported format.',
      error_invalid_format_fix: 'Save the file as .xlsx, .xls, or .csv and try again',
      error_no_data: 'No data rows found',
      error_no_data_desc: 'The file contains headers but no data rows.',
      error_no_data_fix: 'Add customer data below the header row',
      error_corrupted: 'File appears corrupted',
      error_corrupted_desc: 'The file could not be opened. It may be damaged.',
      error_corrupted_fix: 'Try opening the file in Excel, save it again, and re-upload',
      error_too_many_rows: 'Too many rows',
      error_too_many_rows_desc: 'The file contains more than 10,000 rows.',
      error_too_many_rows_fix: 'Split the file into smaller parts with up to 10,000 rows each',
      error_unknown: 'Unknown error',
      error_unknown_desc: 'An unexpected error occurred while processing the file.',
      error_unknown_fix: 'Please try again or contact support',
      error_upload_failed: 'Upload failed',
      error_try_again: 'Please check the file and try again',
      error_server: 'Server error',
      error_server_desc: 'The server could not process this file. The file may be too large or contain too many rows.',
      error_server_fix: 'Try splitting the file into smaller parts (up to 1000 rows each) or contact support',
      error_file_not_found: 'File not found',
      error_file_not_found_desc: 'The uploaded file could not be found in storage. The upload may have failed.',
      error_file_not_found_fix: 'Please try uploading the file again'
    },
    customers_of: 'Customers of',
    new_customer: 'New customer',
    customer_details: 'Customer details',
    data_error: 'There is a problem with customer details, please contact system administrator',
    table: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      fullName: 'Full name',
      segments: 'Segments',
      birth_date: 'Birth date',
      last_participation: 'Last Participation',
      participation: 'Participation',
      created_at: 'Joined',
      social: 'Social',
      status: 'Status',
      join_date: 'Join date',
      cancel_date: 'Cancel date',
      price: 'Price',
      marketing_approval: 'Marketing approval',
      production: 'Production',
      go_to_order_page: 'Go to order page',
      search: {
        advanced: 'Advanced search',
        users_in_segments: 'Search users in these segments'
      }
    },
    exclude_segments: 'Exclude users in these segments',
    search_from_date: 'Search from date',
    search_date_tooltip: 'Search for ticket purchase, subscription, or activity performed from this date, within existing segments',
    search_to_date_tooltip: 'Search for ticket purchase, subscription, or activity performed until this date, within existing segments',
    search_price_tooltip: 'Search for ticket purchase, subscription, or activity with price higher than this, within existing segments',
    search_max_price_tooltip: 'Search for ticket purchase, subscription, or activity with price lower than this, within existing segments',
    min_price: 'Minimum price',
    max_price: 'Maximum price',
    go_to_order_page: 'Go to order page',
    create_new_order: 'Create new order',
    for_customer: 'For customer',
    select_production: 'Select production',
    productions_with_future_events: 'Productions with future events',
    select_event: 'Select event',
    cannot_select_event_before_production: 'Cannot select event before selecting production',
    future_events_only: 'Future events only',
    select_subscription: 'Select subscription',
    cannot_select_subscription_no_active: 'Cannot select subscription when there are no active subscriptions',
    order_history: 'Order history',
    activity_history: 'Activity history',
    comments: 'Comments',
    charges: 'Charges',
    create_new_charge_tooltip: 'Charge the customer\'s credit card',
    create_new_charge: 'Create new charge',
    token_auto_filled: 'Token automatically filled from user data',
    charge_created_successfully: 'Charge created successfully',
    charge_new_credit_card: 'Charge New Credit Card',
    charge_stored_credit_card: 'Charge Stored Credit Card',
    confirm_charge: 'Confirm Charge - {{amount}}',
    charge_confirmation_message: 'Are you sure you want to charge this user?',
    confirm_charge_button: 'Confirm Charge',
    charge_confirmation_title: 'Charge Confirmation',
    charge_confirmation_after_approval: 'After approving this action',
    charge_confirmation_will_be_charged: 'will be charged',
    charge_confirmation_for: 'for',
    charge_confirmation_do_you_approve: 'Do you approve?',
    customer_credit_card: 'Customer credit card',
    dining_analytics: 'Dining Analytics',
    dining: {
      filter_by_date: 'Filter by Date Range',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset: 'Reset',
      total_spent: 'Total Spent',
      total_visits: 'Total Visits',
      average_spend: 'Average Spend per Visit',
      average_duration: 'Average Visit Duration',
      spending_breakdown: 'Spending Breakdown',
      spending_details: 'Spending Details',
      food: 'Food',
      drinks: 'Drinks',
      visit_history: 'Visit History',
      no_visits: 'No visits found for selected date range',
      table: 'Table',
      minutes: 'min',
      total: 'Total',
      order_items: 'Order Items',
      total_spending: 'Total'
    },
    store_credit_card_for_future: 'Store this credit card for future charges',
    no_seller_public_key: 'Seller public key not configured',
    search_to_date: 'Search to date',
    already_refunded_amount: 'Order has already been refunded amount - {{amount}}',
    tickets_return_caption: 'The marked tickets will be returned to the ticket pool for sale',
    buyer_paid_fee: 'Fee amount (paid by buyer) - {{amount}}',
    ticket_cancelled_no_refund: 'Cancelled without refund',
    refund_amount_label: 'Choose refund amount',
    refund_amount_helper: 'Refund amount cannot exceed order amount',
    order_amount: 'Order amount - {{amount}} NIS',
    ticket_refunded: 'Refunded',
  },
  booked_events: 'Booked events',
  my_subscriptions: 'My subscriptions',
  financial: 'Financial',
  manual_segment: 'Manual segment',
  event_segment: 'Event segment',
  finance_segment: 'Finance segment',
  activity: 'Activity',
  hide: 'Hide',
  verification_code: 'Verification code',
  male: 'Male',
  female: 'Female',
  other: 'Other',
  my_productions: 'My productions',
  events: 'Events',
  system_users: 'System users',
  system_users_title: 'System users',
  switch: 'Switch',
  general_error: 'General error',
  no_permission: 'You do not have permission for this operation',
  general_success: 'General success',
  handler_not_unique: 'Short URL already exists',
  change_to_light_mode: 'Change to light mode',
  change_to_dark_mode: 'Change to dark mode',
  random_image: 'Random image',
  my_account: 'My Account',
  entry_code: 'Entry Code',
  join_date: 'Join date',
  iterations_completed: 'Iterations completed',
  phone: 'Phone',
  fname: 'First name',
  lname: 'Last name',
  email: 'Email',
  search: 'Search',
  cancel_date: 'Cancel date',
  created_at: 'Created at',
  from: 'From',
  to: 'To',
  refresh: 'Refresh',
  refresh_success: 'Refresh success',
  cancel_date_to: 'Cancel date to',
  cancel_date_from: 'Cancel date from',
  my_details: 'My details',
  edit_account_details: 'Edit account details',
  sms: {
    page_title: 'Send SMS',
    phone_number: 'Phone number',
    phone_numbers: 'Phone numbers',
    no_phone_numbers: 'No phone numbers',
    select_from_segment: 'Select from segment',
    select_segments: 'Select segments',
    submit: 'Submit',
    sent_success: 'Message sent successfully',
    send: 'Send',
    total_phones: 'Total phones',
    campaign_name: 'Campaign name',
    campaign_content: 'Campaign content',
    add: 'Add',
    fill_field: 'Please fill this field',
    duplicate_numbers: 'Duplicate numbers found',
    add_number: 'Add number',
    approve: 'Approve',
    close: 'Close',
    no_sms_campaigns: 'No SMS campaigns',
    segment_phones: 'Segment phone numbers',
    numbers: 'Numbers',
    you_have_x_sms_credits_left: 'You have {{x}} SMS credits left',
  },
  sales_table: 'Sales table',
  my_members: {
    title: 'My Members',
    error_loading: 'Error loading my members',
    refresh: 'Refresh',
    refresh_success: 'Data updated successfully',
    search: 'Search',
    name: 'Name',
    from: 'From',
    to: 'To',
    general_error: 'General error',
    payment_issue: 'Payment Issue',
    payment_failed_attempt: 'Attempt {{count}}',
    payment_retry_daily: 'The system retries charging daily',
    profile_status: 'Profile Status',
    profile_complete: 'Complete',
    profile_incomplete: 'Missing details',
  },
  terms_of_service: 'Terms of Service',
  privacy_policy: 'Privacy Policy',
  name: 'Name',
  price_from: 'Price from',
  price_to: 'Price to',
  date_from: 'Date from',
  date_to: 'Date to',
  all: 'All',
  active: 'Active',
  not_active: 'Not active',
  no_available_slots: 'No available slots',
  left: 'left',
  roles: {
    all: 'All',
    scanner: 'Scanner',
    trainer: 'Trainer',
    reader: 'Reader',
    editor: 'Editor',
    admin: 'Admin',
    promoter: 'Promoter',
    cashier: 'Cashier',
    owner: 'Owner',
  },
  role: 'Role',
  invite: 'Invite',
  clear: 'Clear',
  remove_user_dialog: {
    title: 'Remove User',
    confirm_prefix: 'Do you want to remove',
    remove_from_segment: 'Remove customers from segment',
    selected_users: 'Selected users'
  },
  edit_user_permissions: 'Edit user permissions',
  invitation_link: 'Invitation link',
  users: 'Users',
  invited: 'Invited',
  add_user: 'Add user',
  collaborator_name: 'Collaborator name',
  roles_info: {
    title: 'Role Permissions',
    reader: 'Can view most data but cannot create, edit, or delete',
    editor: 'Can view and edit all data except collaborator management',
    admin: 'Full access — can do everything including managing collaborators',
    scanner: 'Can only scan tickets (for mobile scanning app)',
    promoter: 'Can only see their own links and total purchases made through those links',
    cashier: 'Has permission to all cashier features',
  },
  header: {
    home: 'Home',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    create_event: 'Create event',
    book_demo: 'Book demo',
    signin: 'Sign in',
    my_account: 'My account',
    subscriptions: 'Subscriptions',
    entry_pass: 'Entry pass',
    events: 'Events',
  },
  MYKIND: {
    home: {
      title: 'Ticket sales and event management for customers with requirements',
      subtitle: 'Quick response even during peak hours, seat selection and seating such as stands, ticket scanner for events without cellular reception',
      main_cta: 'Start selling'
    },
  },
  EASYTIX: {
    home: {
      title: 'Ticket sales and event management for customers with special requirements',
      subtitle: 'Including seating, ticket scanning app and sales statistics',
      main_cta: 'Start selling'
    },
  },
  HORMESIS: {
    home: {
      title: 'Ticket sales and event management for customers with special requirements',
      subtitle: 'Including seating, ticket scanning app and sales statistics',
      main_cta: 'Start selling'
    },
  },
  ZOA: {
    home: {
      title: 'Ticket sales and event management for customers with special requirements',
      subtitle: 'Including seating, ticket scanning app and sales statistics',
      main_cta: 'Start selling'
    },
  },
  MINKOVSKY: {
    home: {
      title: 'Ticket sales and event management for customers with special requirements',
      subtitle: 'Including seating, ticket scanning app and sales statistics',
      main_cta: 'Start selling'
    },
  },
  COMEDYCLUB: {
    home: {
      title: 'Ticket sales and event management',
      subtitle: 'Including season ticket, ticket scanning and sales statistics',
      main_cta: 'Start selling'
    },
  },
  RADICAL: {
    home: {
      title: 'Ticket sales and event management for customers with special requirements',
      subtitle: 'Including seating, ticket scanning app and sales statistics',
      main_cta: 'Start selling'
    },
    terminology: {
      'event_page.season_ticket_discount_will_appear_after_choosing_tickets': 'Season ticket discount will appear after choosing tickets',
      'sales_table_head.season_tickets': 'Members',
    },
  },
  ACCADIA: {
    home: {
      title: 'VILLA',
      main_cta: 'Admin Login',
      subtitle: 'a place to be',
    }
  },
  TARBUTA: {
    home: {
      title: '',
      main_cta: 'Login',
      subtitle: 'Lectures by the best lecturers',
    }
  },
  sales_table_head: {
    season_tickets: 'Subscribers',
  },
  auth: {
    login: 'Login',
    new_password: 'New password',
    approve: 'Approve',
    reset_password: 'Reset password',
    send_reset_password: 'Send reset password email',
    new_user: 'Not registered yet',
    join_us: 'Join us',
    forgot_password: 'Forgot password',
    login_title: 'Hi, welcome back!',
    or: 'Or',
    already_have_an_account: 'Already registered',
    create_account: 'Create account',
    wrong_credentials: 'Wrong credentials',
    been_invited: 'You have been invited to',
    already_exists_email: 'Email already exists',
    invalid_email: 'Invalid email address',
    invite_himself_error: 'User cannot invite themselves',
    reset_password_success: 'Request completed successfully, please check your email 👍',
    email: 'Email',
    passwords_must_match: 'Please make sure passwords match',
    password_reset_success: 'Password reset successfully 👍',
    password: 'Password',
    verify_password: 'Verify password',
    create_account_to_accept_invite: 'To accept the invitation you need to create an account',
    invitation_expired: 'This invitation link has expired. Please ask for a new invitation.',
    welcome_to_nimi: 'Welcome to Nimi!',
    company_name_english_only: 'Company name in English only',
    company_name_required: 'Company name is required',
    start_selling_title: 'Quick registration and start',
    start_selling_description: 'Immediately after registration you can set up productions, create events and sell tickets',
    start_selling_submit: 'Submit',
    click_here_to_login: 'Click here to login',
    '2fa': {
      title: 'Two-Factor Authentication',
      description: 'A verification code was sent to {{email}}',
      code_label: 'Verification Code',
      code_required: 'Verification code is required',
      code_format: 'Code must be 4 digits',
      verify_button: 'Verify',
      resend_code: 'Resend code',
      resend_timer: 'Resend available in {{seconds}}s',
      code_resent: 'Verification code sent successfully',
      code_expired: 'Verification code has expired. Please login again.',
      code_invalid: 'Invalid verification code. Please try again.',
      no_pending: 'No pending verification found. Please login again.',
      resend_cooldown: 'Please wait before requesting a new code',
      invalid_access: 'Invalid access. Please login first.',
      success: 'Verification successful! Redirecting...',
    },
    bank_details: {
      gov_id_issue_date: 'ID issue date',
      bank_code: 'Bank code',
      bank_branch: 'Bank branch number',
      bank_account_number: 'Bank account number',
      iban: 'IBAN (Optional)',
      company_name: 'Company name',
      company_name_english_only: 'In English only',
      city: 'City',
      street: 'Street',
      house_number: 'House number',
      business_type: 'Business type',
      business_types: {
        private: 'Private',
        ltd: 'Ltd',
        exempt: 'Exempt',
        non_profit: 'Non Profit',
        public: 'Public company'
      },
      finish: 'Finish'
    }
  },
  dashboard: {
    title: 'Dashboard',
    search: 'Search',
    main: 'Main',
    selected: 'Selected',
    season_ticket_status: 'Season ticket status',
    my_leads: 'My Leads',
    no_leads: 'No leads found',
    legal: {
      title: 'Terms and conditions settings',
      terms_of_service: 'Terms of service',
      privacy_policy: 'Privacy policy',
      terms_of_club_membership: 'Terms of club membership',
      submit: 'Save',
      success: 'Details saved successfully',
      error: 'Error saving details',
    },
    events: {
      search_events: 'Search events...',
      income_after_credits_and_fee: 'Income after credits and fee',
      income_data: 'Income data',
      ticket_data: 'Ticket data',
      buyer_data: 'Buyer data',
      event_type: 'Event type',
      choose_event_type: 'Choose event type',
      divided_order_approvable_not_allowed: 'Cannot approve split payment order before payment approval',
      handler_already_exists: 'Short URL already exists, try choosing a different one',
      unauthorized: 'User does not have access to this page',
      event: 'Event',
      new_event: 'New event',
      default_event_notice: 'This is the default event. All new events will inherit the settings from this event.',
      default_event: 'Default event',
      edit_event: 'Edit event',
      my_events: 'My events',
      create_new_event: 'Create new event',
      event_name: 'Event name',
      description: 'Description',
      content: 'Content',
      design: 'Design',
      marketing: 'Marketing',
      embedding: 'Embedding',
      embedding_explainer: 'Want to add something we don\'t have yet? You can embed code here',
      background_color: 'Background color',
      buttons_color: 'Buttons color',
      progress_bar_color: 'Progress bar color',
      privacy_policy_color: 'Privacy policy color',
      cover_photo: 'Cover photo',
      event_photo: 'Event photo',
      tickets: 'Tickets',
      seats_tickets: 'Tickets for marked seats',
      ticket_name: 'Ticket name',
      price: 'Price',
      amount: 'Amount',
      start_date: 'Start date',
      end_date: 'End date',
      location: 'Location',
      email_to_contact: 'Contact email',
      search: 'Search orders (order #, name, phone, time, date)...',
      search_production_users: 'Search production users...',
      search_system_users: 'Search system users...',
      tickets_sale_status: 'Tickets sale status',
      edit: 'Edit',
      view: 'View',
      start_hour: 'Start hour',
      end_hour: 'End hour',
      active_from_date: 'Available from date',
      inactive_from_date: 'Available until date',
      active: 'Active',
      active_in_main_page: 'Active in main page',
      inactive: 'Inactive',
      new_ticket: 'New ticket',
      duplicate: 'Duplicate',
      set_as_default: 'Set as default',
      set_as_default_description: 'If you set this event as the default, all new events will use it as a template.',
      remove: 'Remove',
      event_handler: 'Short URL',
      preview: 'Preview',
      create_event: 'Create event',
      required_field: 'This field is required',
      must_be_greater: 'Must be greater than {{0}}',
      must_be_less: 'Must be less than {{0}}',
      min_length: 'Minimum length is {{0}} characters',
      max_length: 'Maximum length is {{0}} characters',
      invalid_form: 'Form is invalid',
      english_letters_only: 'English letters only and no spaces',
      invalid_email: 'Invalid email address',
      invalid_url: 'Invalid URL format',
      all_orders: 'All orders',
      waiting_for_approval: 'Orders waiting for approval',
      rejected_orders: 'Rejected orders',
      approved_orders: 'Approved orders',
      refunded_orders: 'Refunded orders',
      ordered_after_limit_reached: 'Late orders',
      name_already_exists: 'A ticket with this name already exists',
      no_events: 'No events',
      crete_event: 'Create event',
      facebook_page: 'Facebook page',
      facebook_pixel: 'Facebook pixel',
      facebook_pixel_explainer: 'Please enter ID only',
      facebook_pixel_explainer_link: 'What is Facebook pixel?',
      facebook_pixel_explainer_link_2: 'How to create Facebook pixel?',
      google_analytics_id: 'Google Analytics',
      google_analytics_id_explainer: 'Please enter ID only',
      google_analytics_id_explainer_link: 'What is Google Analytics?',
      google_analytics_id_explainer_link_2: 'How to create Google Analytics ID?',
      facebook_pixel_info_what: 'What is a Facebook Pixel?',
      facebook_pixel_info_what_body: 'A Facebook Pixel is a piece of code that tracks visitor activity on your event page and sends it to Facebook — enabling retargeting ads and conversion tracking.',
      facebook_pixel_info_where: 'Where do I find my Pixel ID?',
      facebook_pixel_info_where_body: 'Go to Facebook Events Manager → Select your Pixel → The ID is the number shown under the Pixel name.',
      facebook_pixel_info_where_link: 'Open Facebook Events Manager',
      facebook_pixel_info_verify: 'How do I verify it\'s working?',
      facebook_pixel_info_verify_body: 'Install the Facebook Pixel Helper Chrome extension. Open your event page — the icon turns green when the pixel fires.',
      facebook_pixel_info_extension: 'Install Facebook Pixel Helper',
      google_analytics_info_what: 'What is a Google Analytics ID?',
      google_analytics_info_what_body: 'Your Measurement ID lets you track how many people visit your event page, where they come from, and what they do.',
      google_analytics_info_where: 'Where do I find my Measurement ID?',
      google_analytics_info_where_body: 'Go to Google Analytics → Admin → Data Streams → Select your stream → Copy the Measurement ID (starts with G-).',
      google_analytics_info_where_link: 'Open Google Analytics',
      google_analytics_info_verify: 'How do I verify it\'s working?',
      google_analytics_info_verify_body: 'Install the Google Tag Assistant Chrome extension. Open your event page — it shows whether your GA tag is firing correctly.',
      google_analytics_info_extension: 'Install Google Tag Assistant',
      orders: 'Orders',
      event_settings: 'Event settings',
      order_name: 'Order name',
      order_number: 'Order number',
      order_status: 'Order status',
      user_event_status: 'Buyer status',
      ticket_page_link: 'Ticket page link',
      split_payment_link: 'Split payment link',
      order_tickets_amount: 'Number of tickets',
      order_tickets_quantity: 'Total tickets quantity',
      order_total_price: 'Order total price',
      coupon: 'Coupon',
      season_ticket: 'Season ticket',
      order_date: 'Order date',
      order_details: 'Order details',
      event_user_full_name: 'Full name',
      seat: 'Seat',
      event_user_social: 'Social',
      event_user_gender: 'Gender',
      event_user_age: 'Age',
      event_user_phone: 'Phone',
      event_user_email: 'Email',
      event_user_ticket_name: 'Ticket name',
      event_user_paid_price: 'Paid price',
      user_scanned: 'User scanned',
      order_refunded: 'Order refunded',
      order_fully_refunded: 'Order fully refunded',
      order_partial_refunded: 'Order partially refunded',
      cancellation_without_refund: 'Cancellation without refund',
      order_approved: 'Order approved',
      order_pending: 'Order pending',
      divide_order_pending: 'Divide order pending',
      divide_order_active: 'Divide order active',
      divide_order_complete: 'Divide order complete',
      divide_order_failed: 'Divide order failed',
      approve_order: 'Approve order',
      refund_order: 'Refund order',
      reject_order: 'Reject order',
      open_whatsapp: 'Open WhatsApp',
      open_email: 'Open email',
      edit_details: 'Edit details',
      approve: 'Approve',
      reject: 'Reject',
      cancel: 'Cancel',
      should_approve_order: 'Should approve order',
      should_reject_order: 'Should reject order',
      update_event: 'Update event',
      order_approved_successfully: 'Order approved successfully',
      order_refunded_successfully: 'Order refunded successfully',
      no_data: 'No data',
      update: 'Update',
      copy: 'Copy',
      copied: 'Copied',
      question: 'Question',
      answer: 'Answer',
      all_sales: 'All sales',
      sales_per_ticket: 'Sales per ticket',
      paid: 'Paid',
      total_approved: 'Total approved',
      total_paid: 'Total paid',
      total_refunded: 'Total refunded',
      total_coupons_used: 'Total coupons used',
      total_season_tickets_used: 'Total season tickets used',
      available: 'Available',
      refunded: 'Refunded',
      tickets_sold: 'Tickets sold',
      all_tickets: 'All tickets',
      sold_out: 'Sold out',
      must_have_entering_q: 'Must have entering question',
      active_event: 'Active event',
      resend_mail: 'Resend mail',
      show_charges: 'Show charges',
      show_splited_charges: 'Show split charges',
      send: 'Send',
      should_resend_mail: 'Should resend mail',
      close: 'Close',
      should_manual_approve: 'Should manual approve',
      most_close_event: 'Closest first',
      most_far_event: 'Farthest first',
      archive_newest_first: 'Newest first',
      archive_oldest_first: 'Oldest first',
      checked_in: 'Checked in',
      not_checked_in: 'Not checked in',
      apply_check_in: 'Apply check in',
      email_resent: 'Email resent',
      create_new_link: 'Create new link',
      delete_links: 'Delete links',
      delete: 'Delete',
      link: 'Link',
      change_status: 'Change status',
      set_inactive: 'Set inactive',
      set_active: 'Set active',
      all_events: 'All events',
      future_events: 'Future events',
      archive_events: 'Archive events',
      past: 'Past',
      send_refund: 'Send refund',
      charge_status_completed: 'completed',
      charge_status_refund: 'refund',
      charge_status_partial_refund: 'partial refund',
      date: 'Date',
      card_mask: 'Card mask',
      buyer_email: 'Buyer email',
      buyer_name: 'Buyer name',
      buyer_phone: 'Buyer phone',
      card_brand: 'Card brand',
      charge_type: 'Charge type',
      sale_status: 'Sale status',
      charge_sum: 'Charge sum',
      charge_installments: 'Installments',
      invoice: 'Invoice',
      view_invoice: 'View Invoice',
      charge_external_code: 'Charge external code',
      buyer_key: 'Buyer key',
      please_fill_required_fields: 'Please fill in all required fields',
      please_enter_valid_amount: 'Please enter a valid amount',
      error_creating_charge: 'Error creating charge',
      creating: 'Creating...',
      external_transaction_auth_number: 'External transaction auth number',
      max_capacity_explainer: 'Max capacity explainer',
      max_capacity: 'Max capacity',
      error_uploading_image: 'Error uploading image',
      copy_event_link: 'Copy Event Link',
      copy_scanner_link: 'Copy Scanner Link',
      free_ticket_helper: 'For free ticket, enter "0"',
      min_tickets_helper: 'Minimum number of tickets per order',
      min_tickets_label: 'Minimum Order Quantity',
      max_tickets_helper: 'Maximum number of tickets per order',
      max_tickets_label: 'Maximum Order Quantity',
      ticket_order_helper: 'Ticket display position in purchase table',
      ticket_order_label: 'Ticket Position',
      // Advanced settings
      advanced_settings: 'Advanced Settings',
      advanced_settings_active: 'Advanced Settings (configured)',
      // Badge
      badge: 'Badge',
      show_badge: 'Show badge',
      badge_text: 'Badge text',
      badge_preset_coming_soon: 'Coming Soon',
      badge_preset_limited: 'Limited',
      badge_preset_new: 'New!',
      badge_preset_popular: 'Popular',
      badge_preset_last_chance: 'Last Chance',
      disable_purchase: 'Disable purchase',
      disable_purchase_helper: 'Ticket will be visible but not available for purchase',
      badge_max_length: 'Maximum 20 characters',
      // Group Discount
      group_discount: 'Group Discount',
      enable_group_discount: 'Enable group discount',
      discount_rule: 'Discount rule',
      add_rule: 'Add rule',
      from_quantity: 'From',
      to_quantity: 'To',
      discount_percent: 'Discount %',
      unlimited: 'Unlimited',
      group_discount_helper: 'Set quantity-based discount tiers for this ticket',
      group_discount_description: 'Discount text shown on purchase page',
      rule_overlap_error: 'Rules cannot have overlapping quantity ranges',
      min_greater_than_max: 'Minimum must be less than or equal to maximum',
      discount_range_error: 'Discount percentage must be between 1 and 100. Cannot exceed 100%',
      min_quantity_error: 'Minimum quantity must be at least 2',
      seats_ticket_tooltip: 'Enable selling tickets for marked seats for the event',
      event_name_min_length: 'Event name must contain at least 4 characters',
      event_name_letters_only: 'Event name must contain letters',
      no_tickets_for_sale: '- No tickets for sale -',
      tickets_sold_out: 'Sorry, tickets are sold out',
      no_waiting_list: 'This event has no waiting list (don\'t worry, the ticket was not charged)',
      season_ticket_entry_pass: 'Entry Pass',
      entry_pass_usage: 'Used {{0}} out of {{1}}',
      available_entries: 'Entries available for this event',
      no_entries_left: 'No entries left for this event',
      refresh_page_error: 'There is a problem, please try refreshing the page',
      no_access_to_edit: 'No access to edit the event',
      form_validation_error: 'Form is invalid, please check the fields',
      commission_profit: 'Commission Profit',
      amount_to_transfer_to_seller: 'Amount to Transfer to Seller',
      field_updated_successfully: 'Field updated successfully!',
      events_of: 'Events of',
      no_access_to_event_details: 'No access to view event details',
      duplicate_event: 'Duplicate Event',
      duplicate_event_instructions: 'To duplicate the event, please choose a new short URL',
      email_status_error: 'We only send emails for orders with status \'pending\' or \'approved\'. Not for status \'{0}\'',
      copy_suffix: 'Copy',
      order_rejected: 'Order rejected',
      new_order: 'New order',
      already_refunded_amount: 'Order has already been refunded amount - {{amount}}',
      tickets_return_caption: 'The marked tickets will be returned to the ticket pool for sale',
      ticket_cancelled_no_refund: 'Cancelled without refund',
      font_customization: 'Font Customization',
      fab_settings: 'Floating Action Button Settings',
      show_fab: 'Show Floating Action Button',
      show_fab_note: 'Enable floating action button on the event page',
      fab_text: 'Floating Action Button Text',
      fab_text_helper: 'Text to display on the floating action button',
      terms: {
        title: 'Event Terms',
        upload_cta: 'Upload PDF',
        upload_helper: 'PDF only · up to 5 MB',
        require_confirmation: 'Require buyers to confirm before payment',
        replace: 'Replace',
        remove: 'Remove',
        validation_required_without_pdf: 'Upload a PDF before requiring confirmation',
        pdf_only: 'PDF files only',
        max_size: 'File must be under 5 MB',
        upload_failed: 'Upload failed',
        default_filename: 'terms.pdf',
      },
    },
    sms_campaign: {
      file_extension_error: 'File extension error',
      name: 'Name',
      content: 'Content',
      phones: 'Phones',
      edit: 'Edit',
      properties: 'Properties',
      recipients: 'Recipients',
      summary: 'Summary',
      upload_phone_numbers_from_excel_file: 'Upload phone numbers from Excel file',
      sms_upload_support_files: 'SMS upload support files',
      upload_phones_numbers_manually: 'Upload phone numbers manually',
      start_create_sms_campaign: 'Start create SMS campaign',
      sms_alert_duplicate_phone_numbers_are_not_allowed: 'Duplicate phone numbers are not allowed',
      sms_alert_please_provide_all_phone_numbers: 'Please provide all phone numbers',
      sms_alert_make_sure_that_no_number_has_not_been_added_to_the_list: 'Make sure that no number has been added to the list',
      sms_alert_invalid_israeli_phone_numbers_provided: 'Invalid Israeli phone numbers provided',
      sms_alert_chars_must_be_less_then_1000_characters: 'Characters must be less than 1000',
      sms_alert_add_phone_number: 'Add phone number',
      sms_campaign_content: 'SMS campaign content',
      sms_campaign_name: 'SMS campaign name',
      sms_campaign_counter_number: 'SMS campaign counter number',
      sms_campaign_created_at: 'SMS campaign created at',
      sms_excel_upload_example: 'SMS Excel upload example',
      sms_excel_upload_first_file: 'SMS Excel upload first file',
      sms_excel_upload_second_file: 'SMS Excel upload second file',
      sms_excel_upload_third_file: 'SMS Excel upload third file',
      sms_unable_to_add_phone_numbers: 'Unable to add phone numbers',
    },
    income: 'Income',
    fee: 'Fee',
    name: 'Name',
    system_fee: 'System fee',
    tickets_quantity: 'Tickets quantity',
    average_tickets_per_order: 'Average tickets per order',
    sales_percentage: 'Sales percentage',
    settings: {
      general: 'General',
      questions_for_buyers: 'Questions for buyers',
      custom_questions: {
        add_new: 'Add new question',
        placeholder: 'Enter question text',
        question_number: 'Question {{0}}',
        required_field: 'Required field',
        field_type: 'Field type',
        field_title: 'Field title',
        types: {
          free_text: 'Free text',
          yes_no: 'Yes/No',
          date: 'Date'
        }
      }
    },
    stats: {
      gender_distribution: 'Gender distribution',
      age_distribution: 'Age distribution',
      age: 'Age',
      count: 'Quantity',
      average_age: 'Average age',
      scanned_tickets: 'Scanned tickets'
    },
    profile_settings: {
      font_upload_error: 'Error uploading font',
      handler_required_notice: 'Handler is required',
      seller_page_link: 'Seller page link',
      seller_scanner_page_link: 'Seller scanner link',
      background_image: 'Background image',
      background_image_mobile: 'Background image (mobile)',
      profile_image: 'Profile image',
      profile_image_is_logo: 'Use profile image as logo',
      name: 'Name',
      short_url: 'Short URL',
      short_url_placeholder: 'Enter short URL',
      settings: 'Settings',
      show_header: 'Show header',
      allow_subscriptions: 'Allow subscriptions',
      hide_login_link: 'Hide login link',
      hide_signup_link: 'Hide signup link',
      hide_subscription_link: 'Hide subscription link',
      hide_entry_pass_link: 'Hide entry pass link',
      hide_event_link: 'Hide events link',
      hide_title: 'Hide title',
      season_ticket_grants_entrance: 'Season ticket grants entrance via QR code',
      seller_page_design: 'Seller page design',
      seller_page_event_design: 'Seller page event design',
      seller_page_event_design_helper: 'Note that you can set color also as transparent or semi-transparent',
      image_overlay: 'Event image overlay',
      event_layout: 'Event layout',
      default_layout: 'Default layout',
      masonry_layout: 'Masonry layout',
      event_filter: 'Event filter',
      event_filter_ui_element: 'Event filter UI element',
      no_filter: 'No filter',
      by_production: 'By production',
      by_event_type: 'By event type',
      dropdown: 'Dropdown',
      tabs: 'Tabs',
      buttons: 'Buttons',
      button_group: 'Button group',
      event_filter_default: 'Default filter value',
      event_filter_default_helper: 'Set a default value to pre-filter events when the page loads',
      event_filter_default_placeholder: 'e.g., production-name or event-type',
      event_text_color: 'Event text color',
      event_label_color: 'Event label color',
      event_label_position: 'Event label position',
      on_image: 'On image',
      under_image: 'Under image',
      centered: 'Centered',
      space_between: 'Space between',
      event_label_content: 'Event label content',
      event_label_content_helper: 'Select which information to display in the event label',
      title: 'Title',
      date: 'Date',
      day: 'Day',
      hour: 'Hour',
      'date-day-hour': 'One line date & time',
      date_day_hour: 'Date & time column',
      date_day_hour_line: 'Date & time line',
      participants: 'Participants',
      participants_bar: 'Participants bar',
      'participants-bar': 'Participants bar',
      waiting_list: 'Waiting list',
      'waiting-list': 'Waiting list',
      trainer: 'Trainer',
      show_entrance_code: 'Show entrance code',
      entrance_code_modal_title: 'Entrance Code',
      entrance_code_description: 'Show this QR code at the entrance.'
    },
    credits: 'Credits',
    total: 'Total',
    create_monthly_report: 'Create monthly report',
    download_data: 'Download data',
    club_member: 'Club member',
    total_income_from_tickets: 'Total income from tickets',
    my_profile: 'My profile',
    seller_page: 'Seller page',
    total_credits_made: 'Total credits made',
    amount_details: 'Amount details',
    income_after_credits_and_fee: 'Income after credits and fee',
    commission_profit: 'Commission Profit',
    amount_to_transfer_to_seller: 'Amount to Transfer to Seller',
    analytics: {
      sellers: 'Sellers',
      events: 'Events',
      purchases_count: 'Purchases count',
      total_purchases: 'Total purchases',
      commission_profit: 'Commission profit',
      amount_to_transfer: 'Amount to transfer'
    },
    my_documents: 'My Documents',
    bank_details_tab: 'Bank Details',
    invoices: 'Invoices',
    invoice_settings: {
      invoice_provider: 'Invoice Provider',
      invoice_provider_token: 'API Token',
      invoice_doc_type: 'Document Type',
      should_send_invoice: 'Send Invoice Automatically',
      receipt: 'Receipt',
      invoice_receipt: 'Invoice Receipt',
      token_helper_text: 'Enter your iCount API token',
      provider_helper_text: 'Invoice provider cannot be changed',
      token_required: 'API Token is required when invoicing is enabled',
      token_help_title: 'How to get your iCount API Token',
      token_help_description: 'Follow these steps to get your API token from iCount and start sending invoices automatically.',
      token_step1_title: 'Copy the registration link',
      token_step1_description: 'Copy this link: https://www.icount.co.il/r/?aff=968438',
      token_step2_title: 'Create an account',
      token_step2_description: 'Go to the link and create your iCount account.',
      token_step3_title: 'Get your API Token',
      token_step3_description: 'Navigate to Account Settings in your iCount dashboard and copy your API token.',
      how_to_get_token: 'How to get your token?',
    },
    email_notifications: {
      tab_title: 'Email Notifications',
      title: 'Email Notification Settings',
      description: 'Control which emails are sent to your customers, team members, and system notifications.',
      customer_emails: 'Customer Emails',
      customer_emails_desc: 'Emails sent to buyers after purchases and transactions',
      system_emails: 'System Emails',
      system_emails_desc: 'Account-related system notifications',
      team_emails: 'Team Emails',
      team_emails_desc: 'Emails sent to team members and collaborators',
      order_confirmation: 'Order Confirmation',
      order_confirmation_desc: 'Sent when an order is completed',
      refund_notification: 'Refund Notification',
      refund_notification_desc: 'Sent when a refund is processed',
      order_pending: 'Order Pending Approval',
      order_pending_desc: 'Sent when order requires approval',
      order_rejected: 'Order Rejected',
      order_rejected_desc: 'Sent when order is rejected',
      subscription_confirmation: 'Subscription Confirmation',
      subscription_confirmation_desc: 'Sent for season ticket purchases',
      special_tickets: 'Special Tickets',
      special_tickets_desc: 'Delivery of special/comp tickets',
      friend_suggestions: 'Friend Suggestions',
      friend_suggestions_desc: 'Automated friend recommendation emails',
      password_reset: 'Password Reset',
      password_reset_desc: 'Password recovery emails',
      email_verification: 'Email Verification',
      email_verification_desc: 'Email address verification',
      account_invitation: 'Account Invitation',
      account_invitation_desc: 'Invite team members to account',
      new_account_invitation: 'New Account Invitation',
      new_account_invitation_desc: 'Invitation to join new accounts',
      new_seller_registered: 'New Seller Registered',
      new_seller_registered_desc: 'Notification of new seller registration',
      warning_order_confirmation: 'Warning: Disabling this will prevent buyers from receiving their tickets via email.',
      warning_password_reset: 'Warning: Disabling this may prevent users from recovering their passwords.',
      warning_refund: 'Warning: Buyers will not receive email confirmation of their refunds.',
    },
    seller_productions_details: 'Seller Productions Details',
    production_name: 'Production Name',
    number_of_events: 'Number of Events',
    number_of_purchases: 'Number of Purchases',
    total_production_purchases: 'Total Production Purchases',
    total_production_purchases_after_refunds: 'Total Production Purchases After Refunds',
    production_events_details: 'Production Events Details - {{0}}',
    event_name: 'Event Name',
    purchases_count: 'Purchases Count',
    total_event_purchases: 'Total Event Purchases',
    total_event_purchases_after_refunds: 'Total Event Purchases After Refunds',
    seller_name: 'Seller Name',
    commission_percentage: 'Commission Percentage',
    commission_profit_with_vat: 'Commission Profit with VAT',
    commission_profit_net: 'Net Commission Profit',
    commission_profit_net_info: 'Commission profit after system fee deduction - {0}%',
    amount_to_transfer_info: {
      title: 'Total purchases amount after refunds minus:',
      line1: '1. Number of purchases times one shekel',
      line2: '2. Number of refunds times 4.5 {{currency}} plus VAT (5.265)',
      line3: '3. For events where commission is taken from seller not buyer - deduction of set commission percentage from total purchases'
    },
    money_transferred_to_seller: 'Money Transferred to Seller',
    error_close_and_try_again: 'There is an error, please close the window and try again',
    create_new_order: 'Create new order',
    customers_club: 'Customers Club',
    back_to_customers: 'Back to customers',
    production: {
      production_settings: 'Production Settings',
      settings_explainer: 'These settings will be the default for every new event created under this production',
    },
  },
  lead: {
    add_new: 'Add New Lead',
    created_success: 'Lead created successfully',
    status_updated_success: 'Lead status updated successfully',
    details: 'Lead Details',
    additional_info: 'Additional Information',
    status: 'Status',
    origin: 'Origin',
    status_initial: 'Initial',
    status_cold: 'Cold',
    status_warm: 'Warm',
    status_approved: 'Approved for subscription purchase',
    status_paying: 'Paying member',
  },
  my_leads_page: {
    title: 'My Leads',
    no_leads_found: 'No leads found',
    add_new_lead: 'Add New Lead',
    lead_created_success: 'Lead created successfully',
    lead_status_updated_success: 'Lead status updated successfully',
    lead_details: 'Lead Details',
    additional_information: 'Additional Information',
    lead_status: 'Lead Status',
    lead_origin: 'Lead Origin',
    status_initial: 'Initial',
    status_cold: 'Cold',
    status_warm: 'Warm',
    status_approved: 'Approved for subscription purchase',
    status_paying: 'Paying member',
    table_headers: {
      first_name: 'First Name',
      email: 'Email',
      phone: 'Phone',
      date: 'Date',
      origin: 'Origin',
      status: 'Status'
    },
    form_labels: {
      first_name: 'First Name',
      last_name: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      birth_date: 'Birth Date',
      gender: 'Gender',
      lead_status: 'Lead Status',
      lead_origin: 'Lead Origin'
    },
    gender_options: {
      male: 'Male',
      female: 'Female'
    },
    status_options: {
      initial: 'Initial',
      cold: 'Cold',
      warm: 'Warm'
    },
    actions: {
      submit: 'Submit',
      cancel: 'Cancel',
      close: 'Close',
      approve: 'Approve'
    },
    validation: {
      required_field: 'This field is required'
    }
  },
  snackbar: {
    files_updated_successfully: 'Files updated successfully!',
    coupon_deleted_successfully: 'Coupon deleted successfully',
    sub_account_updated_successfully: 'Sub account updated successfully',
    account_updated_successfully: 'Account updated successfully',
    sub_account_created_successfully: 'Sub account created successfully',
    event_created_successfully: 'Event created successfully',
    event_updated_successfully: 'Event updated successfully',
    details_updated_successfully: 'Details updated successfully',
    order_rejected: 'Order rejected',
    coupon_created_successfully: 'Coupon created successfully',
    coupon_updated_successfully: 'Coupon updated successfully',
    season_ticket_discount_created_successfully: 'discount created successfully',
    season_ticket_discount_updated_successfully: 'discount updated successfully',
    link_created_successfully: 'Link created successfully',
    link_updated_successfully: 'Link updated successfully',
    links_deleted_successfully: 'Links deleted successfully',
    invited_successfully: 'Invited successfully',
    collaborate_updated_successfully: 'Collaborate updated successfully',
    event_handler_exists: 'Event handler exists',
    refund_card_error: 'Refund card error',
    marketplace_account_created_successfully: 'Marketplace account created successfully',
    marketplace_account_updated_successfully: 'Marketplace account updated successfully',
    tickets_price_updated_successfully: 'Tickets price updated successfully',
    page_updated_successfully: 'Page updated successfully',
    event_settings_updated_successfully: 'Event settings updated successfully',
    price_level_removed_successfully: 'Price level removed successfully',
    subscription_applied_successfully: 'Subscription applied successfully!',
    coupon_applied_successfully: 'Coupon applied successfully!',
    seller_updated_successfully: 'Seller updated successfully',
    no_changes_made: 'No changes were made'
  },
  event_page: {
    go_to_tickets_selection: 'To Tickets Selection',
    go_to_seats_selection: 'To Seats Selection',
    add_to_calendar: 'Add to calendar',
    chosen_ticket: 'Chosen ticket',
    enter_details: 'Enter details',
    payment: 'Payment',
    order_summary: 'Order summary',
    total_to_pay: 'Total to pay',
    payment_provider: 'Payment Provider',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    pay: 'Pay',
    complete_order: 'Complete order',
    split_order: 'Split order',
    order_details: 'Order details',
    ticket: 'Ticket',
    first_name: 'First name',
    last_name: 'Last name',
    phone: 'Phone',
    email: 'Email',
    invalid_email: 'Invalid email',
    invalid_phone: 'Invalid phone',
    invalid_social_link: 'Invalid social link',
    fb_link_help_button: 'How to copy your Facebook profile link',
    fb_link_help_dialog_title: 'How to copy your Facebook profile link',
    fb_link_help_dialog_subtitle: 'Open Facebook on your phone, tap the three dots on your profile, then "Copy link" from Profile Settings. Paste the result here.',
    fb_link_help_close: 'Close',
    invalid_date: 'Invalid date',
    birth_date: 'Birth date',
    social_link: 'Social link',
    credit_card_number: 'Credit card number',
    credit_card_date: 'Credit card date',
    credit_card_cvv: 'Credit card CVV',
    credit_card_holder_name: 'Credit card holder name',
    pay_now: 'Pay now',
    required_field: 'Required field',
    to_order: 'Book now',
    sold_out: 'Sold out',
    please_choose_tickets: 'Please choose tickets',
    season_ticket_discount_will_appear_after_choosing_tickets: 'Season ticket discount will appear after choosing tickets',
    gender: 'Gender',
    ticket_name: 'Ticket name',
    ticket_price: 'Price',
    season_ticket_discount_ticket_price: 'Season ticket discount ticket price',
    ticket_amount: 'Amount',
    already_exists_email: 'Email already exists',
    already_exists_phone: 'Phone already exists',
    installments_select: 'Pay in {{count}} installment(s)',
    installments_per_month: '{{amount}} × {{count}} months',
    installments_title: 'Split your payment',
    installments_full: 'Full',
    installments_month: 'month',
    installments_total: 'Total: {{amount}}',
    phone_required_reason: 'A phone number is required to process your payment and contact you about your order.',
    already_exists_social: 'Social already exists',
    card_holder_first_name: 'Card holder first name',
    card_holder_last_name: 'Card holder last name',
    cvv_number: 'CVV number',
    card_number: 'Card number',
    card_date: 'Card date',
    social_id_card_number: 'Social ID',
    generic_payment_form_error: 'Generic payment form error',
    unauthorised_payment_form_error: "You don't have permission to perform this action",
    payment_rush_error_one: 'Payment rush error one',
    payment_rush_error_two: 'Payment rush error two',
    invalid_card_number: 'Invalid card number',
    invalid_card_cvv: 'Invalid card CVV',
    refusal_payment: 'Refusal payment',
    payment_provider_internal_error: 'Payment service is temporarily unavailable. Please try again in a few minutes.',
    payment_provider_general_error: 'General payment provider error',
    invalid_card_expiry: 'Invalid card expiry',
    payment_invalid_phone_number: 'Invalid phone number',
    payment_invalid_email: 'Invalid email',
    seats_already_taken: 'Seats already taken',
    missing_fields: 'Missing fields',
    order_success: 'Order success',
    order_created_limit_reached: 'Order created limit reached',
    order_created_waiting_list: 'Order created waiting list',
    new_order: 'New order',
    order_waiting_for_approval: 'Order waiting for approval',
    ticket_by_mail: 'Your tickets are on their way',
    form_error: 'Form error',
    is_approved: 'Is approved',
    supported_payment_method: 'Supported payment method',
    safari_private_mode_message: 'Safari private mode message',
    error_fallback: {
      title: 'Error',
      subtitle: 'An error occurred',
      action_btn_msg: 'Try again',
    },
    error: {
      generic: 'Something went wrong while loading the event. Please try again.',
      network: 'Network error. Please check your connection and try again.',
      timeout: 'Request timed out. Please try again.',
    },
    account_not_found_with_handler: {
      title: 'Account Not Found',
      subtitle: 'The account you are looking for does not exist or has been removed.',
    },
    event_not_found_handler: {
      title: 'Event Not Found',
      subtitle: 'The event you are looking for does not exist or has been removed.',
    },
    event_disabled: {
      title: 'Event Unavailable',
      subtitle: 'This event is currently unavailable or has been disabled by the organizer.',
    },
    not_found: {
      go_home: 'Go Home',
    },
    payme_error: {
      title: 'Payment Error',
      subtitle: 'An error occurred during payment',
      action_btn_msg: 'Try again',
    },
    members_only: {
      title: 'Members Only Event',
      message: 'If you have a subscription, please make sure you are logged in',
      cta: "Log In"
    },
    block_purchase: {
      title: 'Sorry we had to block your purchase',
      action_btn_msg: 'Contact support',
    },
    not_enough_tickets_title: 'Sorry, there are fewer tickets left than the selected quantity',
    not_enough_tickets_subtitle: 'Please try selecting a smaller quantity',
    coupon_not_found: 'Coupon not found or no longer available',
    must_accept_terms: 'You must accept the terms before making a purchase',
    fixed_price_template: 'Fixed Price - ₪{{amount}}',
    purchase_fee: 'Purchase Fee',
    group_discount_info: 'Buy {{min}}+ and get {{percent}}% off!',
    group_discount_applied: '{{percent}}% group discount applied',
    purchase_disabled: 'Not available for purchase',
    coupon_code: 'Coupon Code',
    terms_consent: {
      i_have_read: 'I have read the',
      terms_of_service: 'Terms of Service',
      and_i_agree: 'and I agree',
      to_terms_and_cancellation_policy: 'to the terms and cancellation policy'
    },
    preloaded_user_data: 'subscription owner',
    pending_approval_account_cannot_sell_tickets: 'This seller is pending approval and cannot accept payments yet. Please check back soon.',
    search_to_date: 'Search to date',
    already_refunded_amount: 'Order has already been refunded amount - {{amount}}',
    tickets_return_caption: 'The marked tickets will be returned to the ticket pool for sale',
    buyer_paid_fee: 'Fee amount (paid by buyer) - {{amount}}',
    ticket_cancelled_no_refund: 'Cancelled without refund',
    refund_amount_label: 'Choose refund amount',
    refund_amount_helper: 'Refund amount cannot exceed order amount',
    order_amount: 'Order amount - {{amount}} NIS',
    ticket_refunded: 'Refunded',
    phone_already_exist_for_this_seller: 'Phone already exist for this seller',
    terms: {
      open: 'Open Event Terms',
      view: 'View Event Terms',
      required: 'You must open and confirm',
      checkbox: 'I have read and agree to the event terms',
      confirm_close: 'Confirm & close',
      must_confirm_error: 'Open the event terms and confirm before paying',
      download: 'Download',
      open_in_new_tab: 'Open in new tab',
      preview_failed: 'Could not preview the file',
    },
  },
  time_slots: {
    select_date: 'Select Date',
    select_date_helper: 'Choose your preferred date',
    available_times: 'Available Times',
    season_period: 'Season Period',
    booking_window: 'Booking Window',
    days_in_advance: 'days in advance',
    operating_days: 'Operating Days',
    every_day: 'Every Day',
    spots: 'spots',
    available: 'available',
    only_x_left: 'Only {{count}} left',
    x_spots_left: '{{count}} spots left',
    x_available: '{{count}} available',
    view_grid: 'Grid',
    view_list: 'List',
    view_grid_tooltip: 'Grid view - Show time slots as cards',
    view_list_tooltip: 'List view - Show time slots as a table',
    toggle_view: 'Toggle view mode',
    time: 'Time',
    capacity: 'Capacity',
    status: 'Status',
    action: 'Action',
    select: 'Select',
    selected: 'Selected',
    tap_to_select: 'Tap row to select time slot',
    fully_booked: 'Fully Booked',
    no_slots_available: 'No time slots available',
    try_different_date: 'Please try a different date',
    select_time_helper: 'Select your preferred time slot to continue',
    error_loading_slots: 'Error loading time slots. Please try again.',
    back_to_time_selection: 'Back to Time Selection',
    time_slot: 'Time Slot',
    slot_orders_count: '{{count}} orders',
    slot_tickets: '{{sold}}/{{capacity}}',
    slot_pending: '{{count}} pending',
    slot_closed: 'Closed',
    slot_now: 'NOW',
    download_slot: 'Download {{time}}',
    today: 'Today',
  },
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    weekdays: 'Weekdays',
    monday_thursday: 'Monday - Thursday',
  },
  event_management: 'Event management',
  event_sale_stats: 'Event sale stats',
  edit_event: 'Edit event',
  event_settings: {
    general: 'General',
    questions_for_buyers: 'Questions for buyers',
    time_slots: 'Time Slots',
    enable_time_slots: 'Enable Time Slot Booking',
    time_slots_info: 'Allow customers to book specific time slots for this event',
    time_slots_help: 'Configure different operating hours for each day of the week and manage special dates',
    enable_preview_message: 'Enable time slots to see the preview',
    live_preview: 'Live Preview',
    preview_different_days: 'Preview Different Days',
    schedule: 'Schedule',
    enable_this_day: 'Enable this day',
    opening_time: 'Opening Time',
    closing_time: 'Closing Time',
    time_format_help: 'Format: HH:MM (24-hour)',
    slot_duration_minutes: 'Slot Duration (minutes)',
    duration_help: 'Duration of each time slot',
    capacity_per_slot: 'Capacity per Slot',
    capacity_help: 'Maximum bookings per time slot',
    capacity_min_error: 'Minimum capacity is 1',
    capacity_max_error: 'Maximum capacity is 30,000',
    break_times: 'Break Times',
    add_break: 'Add Break',
    break_start: 'Start',
    break_end: 'End',
    break_label: 'Label',
    no_breaks: 'No break times configured',
    lunch_break: 'Lunch Break',
    breaks_count: '{{count}} breaks',
    preview: 'Preview',
    operating_hours: 'Operating Hours',
    total_slots: 'Total Slots',
    daily_capacity: 'Daily Capacity',
    slots: 'slots',
    bookings: 'bookings',
    special_dates: 'Special Dates',
    add_special_date: 'Add Special Date',
    edit_special_date: 'Edit Special Date',
    no_special_dates: 'No special dates configured',
    date: 'Date',
    status: 'Status',
    reason: 'Reason',
    hours: 'Hours',
    modified_hours: 'Modified Hours',
    select_date: 'Select Date',
    reason_placeholder: 'e.g., Holiday, Special Event',
    custom_hours_toggle: 'Custom Hours (leave off for closed)',
    custom_hours_info: 'Set custom operating hours for this date',
    booking_window: 'Booking Window',
    advance_booking_days: 'Advance Booking (days)',
    advance_booking_help: 'How many days in advance can customers book',
    cutoff_minutes: 'Cutoff Before Slot (minutes)',
    cutoff_help: 'Minimum time before slot when bookings close',
    display_settings: 'Display Settings',
    show_availability: 'Show Availability',
    show_availability_help: 'Display remaining availability count to customers when viewing time slots',
    weekly_summary: 'Weekly Summary',
    active_days: 'Active Days',
    weekly_slots: 'Weekly Slots',
    weekly_capacity: 'Weekly Capacity',
    available_slots: 'Available Slots',
    spots: 'spots',
    slot_duration: 'Slot Duration',
    break_periods: 'Break Periods',
    day_capacity: 'Day Capacity',
    day: 'Day',
    duration: 'Duration',
    capacity: 'Capacity',
    day_not_available: '{{day}} is not available for booking',
    day_statistics: 'Daily Statistics',
    hours_total: 'hours total',
    breaks_configured: 'breaks configured',
    revenue_potential: 'Revenue Potential',
    max_bookings_per_day: 'max bookings per day',
    productive_hours: 'productive hours',
    break_hours: 'break hours',
    break_minutes: 'break minutes',
    preview_day: 'Preview Day',
    choose_date_preview: 'Choose date for preview',
    selected_day: 'Selected day',
    quick_day_selection: 'Quick Day Selection',
    weekly_schedule: 'Weekly Schedule',
    dates_configured: 'dates configured',
    integrations: 'Integrations',
  },
  seats_chart: {
    title: 'Seats Chart',
    no_seats_chart: 'No seats chart',
    select_seats_chart: 'Select seats chart',
    cant_change_after_orders: 'Cannot change seats chart after orders have been made',
    validation_error: 'There is a problem with the seats chart',
    choose: 'Choose',
    edit_categories: {
      title: 'Edit Categories',
      subtitle: 'Edit seating categories for this event only',
      category_name: 'Category name',
      category_color: 'Category color',
      accessibility: 'Accessibility',
      accessibility_tooltip: 'Mark this category as accessible for people with disabilities',
      remove: 'Remove',
      remove_tooltip: 'Remove this category',
      cant_remove_after_orders: 'Cannot remove category after tickets have been sold',
      add_category: 'Add category',
      save: 'Save',
      fill_all_fields: 'Please fill all fields',
      unique_names_required: 'Please ensure each category has a unique name.',
      update_success: 'Categories updated successfully',
      update_error: 'Error updating categories'
    },
    price_levels: {
      default: 'Default',
      enter_name: 'Please enter a name for the price level',
      names_must_be_unique: 'Price level names must be unique',
      price_level: 'Price level',
      price_level_number: 'Price level {0}',
      min_price_error: 'Ticket price must be above ',
      price_level_name_helper: 'For example: Students, or Senior Citizens',
      price_level_name_label: 'Price level name',
      cant_remove_after_sales: 'Cannot remove price level after tickets have been sold',
      remove: 'Remove',
      add_price_level: 'Add price level',
      add_more_price_levels: 'Add more price levels',
      update_prices: 'Update prices',
      ticket_prices: 'Ticket prices'
    },
    edit_mode: 'Edit mode',
    edit_categories_button: {
      title: 'Edit seating categories for this event',
      tooltip: 'Add and edit new categories to the chart to price seats differently, for example first row or VIP seats'
    },
    additional_settings: 'Additional settings',
    mobile_confirm_button: 'Mobile confirm button',
    prevent_orphan_seats: 'Prevent orphan seats',
    chart_studio: {
      title: 'Seats Chart Studio',
      validation_error: 'There are issues with the seats chart, please verify your selection',
      chart_updated: 'Chart updated successfully',
      chart_created: 'Chart created successfully',
      save: 'Save',
      create_new: 'Create new chart'
    },
    paid_seat_warning: {
      title: 'Seat Has Paid Order',
      message: 'Seat {{seat}} belongs to a paid order (Order #{{orderNumber}} - {{userName}}). You cannot release this seat directly.',
      instruction: 'To release this seat, go to the Orders page and process a refund. The seat will be released automatically.',
      go_to_orders: 'Go to Orders Page',
    },
  },
  seats_chart_admin: 'Seats chart admin',
  income_types: {
    page_title: 'Income Types',
    invoice_settings_tab: 'Invoice settings',
    explainer: 'Manage your income types (invoice categories) and assign them to events and subscriptions so accounting reports split revenue by category.',
    create_new: 'Create',
    no_income_types: 'No income types defined yet',
    update: 'Update Income Type',
    create: 'Create Income Type',
    update_button: 'Update',
    create_button: 'Create',
    name: 'Income type name',
    name_helper: 'The name as defined at your invoice provider',
    icount_id: 'Provider income type id (optional)',
    icount_id_helper: 'Copy this from your income type at your invoice provider. Leave blank to match by name.',
    match_by_name_note: 'If you leave the id blank, we send only the name to your invoice provider, which matches or auto-creates the category by name.',
    match_by_name: 'Match by name',
    sends_id_and_name: 'Invoice sends the id and name',
    sends_name_only: 'Invoice sends the name only',
    id_must_be_number: 'The id must be a positive number',
    edit: 'Edit',
    delete: 'Delete',
    created_successfully: 'Income type created successfully',
    updated_successfully: 'Income type updated successfully',
    deleted_successfully: 'Income type deleted successfully',
    field_label: 'Income type',
    field_helper: 'Sent to your invoice provider when the invoice is generated',
    none: 'None (default)',
    deleted: 'deleted',
    default_section_title: 'Default income type',
    default_field_label: 'Default income type for this production',
    event_section_title: 'Income type (invoices)',
    event_section_note: 'Overrides the production default for this event\'s invoices.',
    season_ticket_field_label: 'Invoice income type',
  },
  coupons: {
    page_title: 'Coupons',
    create_new: 'Create New Coupon',
    no_coupons: 'No Coupons',
    update: 'Update Coupon',
    create: 'Create Coupon',
    update_button: 'Update Coupon',
    create_button: 'Create Coupon',
    code: 'Code',
    name: 'Name',
    apply_to_all_active_events_link: 'Apply to all active events',
    long_explainer: "and will apply to future events",
    discount: 'Discount',
    discount_per_ticket: 'Discount per ticket',
    discount_type: 'Discount type',
    percentage: 'Percentage',
    fixed_price: 'Fixed price',
    quantity: 'Quantity',
    quantity_helper: 'For unlimited quantity, enter 0 or leave this field empty',
    active: 'Active',
    not_active: 'Not active',
    unlimited: 'Unlimited',
    used: 'Used',
    edit: 'Edit',
    delete: 'Delete',
    duplicate: 'Duplicate',
    title: 'Coupons',
    applied_to_all_active_events_successfully: 'Coupon applied to {{count}} events successfully',
    apply_to_all_active_events_modal_description: 'Do you want to apply this coupon to all active events?',
    apply_to_all_active_events_modal_title: 'The coupon will apply to all future events',
  },
  tickets: 'Tickets',
  season_tickets_discount: {
    create_new: 'Create new',
    create: 'Create',
    edit: 'Edit',
    discount: 'Discount',
    discount_per_ticket: 'Discount per ticket',
    discount_type: 'Discount type',
    percentage: 'Percentage',
    subscription_type: 'Subscription type',
    update: 'Update',
    fixed_price: 'Fixed price',
    for: 'For',
    entry_pass: 'Entry pass',
    subscription: 'Subscription',
    title: 'Season Tickets Discount',
  },
  event_orders: 'Event orders',
  event_links: 'Event links',
  my_events: 'My events',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
  UNKNOWN: 'Unknown',
  EMAIL_MARKETING_CONSENT: {
    BASIC: 'Consent to receive marketing content by email',
    SHORTER: 'I want to receive email updates',
    LONGER: 'Consent to receive updates and marketing offers by email',
    COOLER: 'Keep me updated on cool events and deals!',
  },
  top_up: {
    title: 'Top up',
    subtitle: 'Add funds to your account',
    success: 'Top up successful',
    amount: 'Amount',
    new_order: 'New order',
    pay: 'Pay',
  },
  calendar_view: {
    event_title: 'Event title',
    event_description: 'Event description',
    update_success: 'Update successful',
    create_success: 'Create successful',
    delete_success: 'Delete successful',
    choose_club_member: 'Choose club member',
    register: 'Register',
    event_type: {
      table_reservation: 'Table reservation',
      tour: 'Tour',
      task: 'Task',
      regular: 'Regular',
      wellness: 'Wellness',
      label: 'Label',
    },
    set_event_type: 'Set event type',
    edit_event: 'Edit event',
    add_event: 'Add event',
    delete_event: 'Delete event',
    create_event: 'Create event',
    update_event: 'Update event',
    tableReservation: {
      guestCount: 'Guest count',
      specialRequests: 'Special requests',
      member: 'Member',
    },
    tour: {
      prospect: {
        firstName: 'First name',
        lastName: 'Last name',
        phone: 'Phone',
      },
      tourGuide: 'Tour guide',
      notes: 'Notes',
    },
    task: {
      assignedTo: 'Assigned to',
      taskStatus: 'Task status',
      status: {
        pending: 'Pending',
        in_progress: 'In progress',
        completed: 'Completed',
      },
    },
  },
  wellness: {
    registrants: 'Registrants',
    registration: 'Registration',
  },
  pricing: {
    billing: 'Billed',
    entries: 'entries',
    purchase: 'Purchase',
    used_entries: 'Used entries',
    out_of: 'out of',
    completed_charges: 'Completed charges',
    subscription_selected: 'This subscription is selected',
    select_subscription: 'Select this subscription',
    single_subscription_note: 'You can only use one subscription at a time',
    i_agree_to: 'I agree to the',
    terms_of_service: 'Terms of Service',
    terms_of_club_membership: 'Terms of Club Membership',
    and: 'and',
    privacy_policy: 'Privacy Policy',
    must_agree_to_terms: 'You must agree to the Terms of Service and Privacy Policy to continue',
    price_template: '${{price}}',
    renewing: 'Renewing',
    until: 'Until',
  },
  chart: {
    total: 'Total',
  },
  navigation: {
    main: 'Main',
    calendar: 'Calendar',
    my_links: 'My Links',
    system_management: 'System Management',
    my_customers: 'My Customers',
    my_subscribers: 'My Subscribers',
    my_sellers: 'My Sellers',
    sellers: 'Sellers',
    visits_timeline: 'Visits Timeline',
    customer_club: 'Customer Club',
    seats_chart_management: 'Seats Chart Management',
    sales_data: 'Sales Data',
    sms_sending: 'SMS Sending',
    legal_settings: 'Legal Settings',
    payment_settings: 'Payment Settings',
    financial_management: 'Financial Management',
    productions_management: 'Productions Management',
    choose_production: 'Choose Production',
    production_users: 'Production Users',
    production_settings: 'Production Settings',
    event_management: 'Event Management',
    event_settings: 'Event Settings',
    coupons: 'Coupons',
    free_tickets: 'Free Tickets',
    season_tickets_discount: 'Season Tickets Discount',
    seats_chart: 'Seats Chart',
    time_slots: 'Time Slots',
    cashier: 'Cashier',
  },
  cashier: {
    add_to_cart: 'Add to Cart',
    active_events: 'Active Events',
    no_active_events: 'No active events at the moment',
    cart: 'Cart',
    checkout: 'Checkout',
    complete_order: 'Complete Order',
    zero_price_cash_only: 'Zero price is only allowed for cash payment',
    new_order: 'New Order',
    order_complete: 'Order Complete!',
    order_number: 'Order',
    first_name: 'First Name',
    last_name: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    optional: 'optional',
    customer_details: 'Customer Details',
    payment_method: 'Payment Method',
    cash: 'Cash',
    pos: 'POS Terminal',
    credit_card: 'Credit Card',
    total: 'Total',
    print: 'Print',
    invoice: 'Invoice',
    tickets: 'Tickets',
    select_tickets: 'Select Tickets',
    select_time_slot: 'Select Time Slot',
    select_time_slot_first: 'Select a time slot first',
    added_to_cart: 'Added to cart',
    remove: 'Remove',
    cart_items: 'Cart Items',
    paid_by: 'Paid by',
    customer: 'Customer',
    cash_given: 'Cash Given',
    change_to_return: 'Change to Return',
    amount_short: 'Amount Short',
    order_failed: 'Order failed. Please try again.',
    invalid_phone: 'Invalid phone number',
    invalid_email: 'Invalid email address',
    free: 'Free',
    pos_devices: 'POS Devices',
    add_device: 'Add Device',
    edit_device: 'Edit Device',
    device_name: 'Device Name',
    device_id: 'Device ID (from PayMe)',
    device_enabled: 'Enabled',
    device_disabled: 'Disabled',
    no_pos_devices: 'No POS devices configured',
    no_enabled_pos_devices: 'No enabled POS devices. Add one in settings.',
    select_pos_device: 'Select POS Device',
    device_created: 'POS device added successfully',
    device_updated: 'POS device updated successfully',
    device_deleted: 'POS device deleted successfully',
    delete_device_title: 'Delete POS Device',
    delete_device_confirm: 'Are you sure you want to delete',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    edit_order: 'Edit Order',
    clear_cart: 'Clear Cart',
    already_paid: 'Already Paid',
    amount_to_pay: 'Amount to Pay',
    edited: 'Edited',
    net_paid: 'Net Paid',
    original_price: 'Original Price',
    total_refunds: 'Total Refunds',
    history: 'History',
    active_tickets: 'Active Tickets',
    removed_tickets: 'Refunded / Removed',
    replaced: 'Replaced',
    charged: 'Charged',
    refunded_label: 'Refunded',
    refunded_to: 'Refunded to',
    edit_history: 'Edit History',
    edit_previous_total: 'Previous Total',
    edit_new_total: 'New Total',
    back_to_orders: 'Back to orders',
    basket_orders: 'Orders',
    basket_search: 'Search by name, phone, order # or last 4 digits...',
    basket_no_orders: 'No orders yet',
    basket_no_results: 'No orders found',
    basket_events_count: 'events',
    basket_copy_link: 'Copy order link',
    basket_open_page: 'Open order page',
    basket_status_completed: 'Completed',
    basket_status_pending: 'Pending',
    basket_status_payment_failed: 'Payment Failed',
    basket_status_cancelled: 'Cancelled',
    basket_status_refunded: 'Refunded',
    'basket_status_partial-refund': 'Partial Refund',
    basket_load_more: 'Load more',
    basket_transaction_details: 'Transaction Details',
    credit_card_declined: 'Card declined. Ask the customer to try another card.',
    credit_card_3ds_required: 'This card requires verification. Use POS or ask customer to pay online.',
    payment_timeout: 'Payment timed out. Check the orders list before retrying.',
    basket_purchase: 'Basket purchase',
    basket_no_charges: 'No transaction details found',
    basket_charge_details: 'Charge Details',
    print_receipt: 'Print Tickets',
    print_invoice: 'Print Invoice',
    print_receipt_doc: 'Print Receipt',
    invoice_pdf: 'Invoice PDF',
    original_invoice: 'Original Invoice',
    original_receipt: 'Original Receipt',
    invoice_number: 'Invoice',
    date: 'Date',
    vat_included: 'Price includes VAT',
    receipt_title: 'Receipt',
    tickets_title: 'Tickets',
    invoice_title: 'Invoice',
    doc_type_invrec: 'Invoice Receipt',
    doc_type_receipt: 'Receipt',
    printer_settings: 'Printer Settings',
    printer_ip: 'Printer IP',
    printer_ip_helper: 'Enter the IPv4 or IPv4:port address of the thermal printer on the network',
    invalid_printer_ip: 'Invalid address. Please enter a valid IPv4 or IPv4:port (e.g. 10.0.0.6 or 10.0.0.6:9100)',
    no_printer_ip: 'No printer IP configured. Please set it in Printer Settings',
    refund: 'Refund',
    refund_order: 'Refund Order',
    refund_all: 'Refund All',
    refund_amount: 'Refund Amount',
    refund_success: 'Refund processed successfully',
    refund_error: 'Refund failed',
    cash_refund: 'Cash refund',
    card_refund: 'Card refund to',
    already_refunded: 'Already refunded',
    refund_receipt_title: 'REFUND',
    refund_original_order: 'Original Order',
    refund_selected_tickets: '{{count}} ticket(s) selected',
    refund_max_amount: 'Max refundable',
    cashier_override_label: 'Cashier price override',
    group_discount_label: 'Group discount',
    coupon_label: 'Coupon',
    season_ticket_label: 'Membership',
    discount_label: 'Discount',
    discount_label_percent: 'Discount {{percent}}%',
    override_price: 'Override Price',
    override_price_pin_title: 'Enter Manager PIN',
    prices_unlocked: 'Prices Unlocked',
    pin: 'PIN',
    incorrect_pin: 'Incorrect PIN. Try again.',
    confirm: 'Confirm',
    analytics_drawer: 'Reports',
    analytics_from: 'From',
    analytics_to: 'To',
    analytics_filter_type: 'Order Type',
    analytics_type_all: 'All',
    analytics_type_online: 'Online',
    analytics_type_frontal: 'Frontal',
    analytics_filter_cashier: 'Cashier',
    analytics_all_cashiers: 'All cashiers',
    analytics_date_col: 'Date',
    analytics_cashier_col: 'Cashier',
    analytics_type_col: 'Type',
    analytics_payment_col: 'Payment',
    analytics_amount_col: 'Amount',
    analytics_orders_col: 'Orders',
    analytics_no_data: 'No data for the selected filters',
    analytics_apply: 'Apply',
    analytics_reset: 'Reset',
    analytics_preset_today: 'Today',
    analytics_preset_yesterday: 'Yesterday',
    analytics_preset_this_week: 'This Week',
    analytics_preset_this_month: 'This Month',
    analytics_summary_total: 'Total',
  },
  basket_order: {
    title: 'Order Confirmation',
    order_number: 'Order',
    event: 'Event',
    ticket: 'Ticket',
    total: 'Total',
    paid_by: 'Paid by',
    customer: 'Customer',
    payment_cash: 'Cash',
    payment_pos: 'POS Terminal',
    payment_credit_card: 'Credit Card',
    minutes: 'min',
    order_time: 'Order time',
  },
  free_tickets: {
    title: 'Free Tickets',
    description: 'Add free orders for your event attendees. You can add them manually one by one, or import a list from an Excel file.',
    manual_entry: 'Manual Entry',
    manual_entry_description: 'Send a free ticket by entering attendee details',
    excel_import: 'Import from Excel',
    excel_import_description: 'Import multiple free orders from an Excel file',
    add_manual: 'Send a Free Ticket',
    import_excel: 'Import from Excel',
    first_name: 'First Name',
    last_name: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    phone_required: 'Phone number is required',
    email_optional: 'Email is optional',
    number_of_tickets: 'Number of Tickets',
    quantity_min: 'Minimum 1 ticket',
    quantity_max: 'Maximum 100 tickets',
    create_ticket: 'Send Free Ticket',
    create_tickets: 'Send {{count}} Free Tickets',
    success_single: 'Free order created successfully',
    success_bulk: '{{count}} free orders created successfully',
    all_failed: 'Failed to create any free orders. Please try again.',
    partial_success: '{{success}} orders created successfully, {{failed}} failed',
    error: 'Error creating free ticket',
    validation_error: 'Please fill in all required fields',
    no_tickets_error: 'No tickets configured for this event',
    excel_format_info: 'Excel File Format',
    excel_format_required: 'Required columns',
    excel_format_optional: 'Optional columns',
    supported_formats: 'Supported formats',
    excel_no_worksheet: 'No worksheet found in Excel file',
    excel_missing_columns: 'Missing Required Columns',
    excel_missing_columns_desc: 'The Excel file must contain columns for First Name, Last Name, and Phone',
    excel_no_valid_rows: 'No Valid Rows Found',
    excel_no_valid_rows_desc: 'The Excel file does not contain any valid rows with required data',
    excel_parse_error: 'Error Parsing File',
    excel_read_error: 'Error Reading File',
    excel_read_error_desc: 'Could not read the uploaded file',
    excel_error: 'Error',
    excel_parsed_success: 'Successfully parsed {{count}} entries',
    excel_invalid_rows: '{{count}} rows were skipped due to missing required fields',
    excel_missing_required: 'Missing required fields (First Name, Last Name, or Phone)',
    excel_preview: 'Preview',
    creating_progress: 'Creating {{current}} of {{total}}...',
    step_upload: 'Upload',
    step_review: 'Review & Create',
    back: 'Back',
    create_special_ticket_title: 'Create Free Ticket Type',
    create_special_ticket_description: 'Before distributing free tickets, you need to create a special free ticket type for this event. This ticket will be used for all free ticket distributions.',
    ticket_name: 'Free Ticket Name',
    default_ticket_name: 'Free Ticket',
    create_button: 'Create Ticket',
    special_ticket_created: 'Free ticket type created successfully',
    ticket_name_already_exists: 'A ticket with this name already exists',
    ticket_settings: 'Free Ticket Settings',
    edit_ticket: 'Edit Ticket',
    ticket_updated: 'Ticket updated successfully',
    save_changes: 'Save Changes',
    importing_title: 'Importing Free Tickets',
    import_in_progress: 'Import is in progress. You can close this dialog and continue working.',
    import_failed_count: '{{count}} failed',
    import_continue_background: 'You can close this dialog. Import will continue in the background.',
    seats_event_info: 'Free tickets are not available for seated events. Please use the Seats Chart to manage seat assignments.',
    go_to_seats_chart: 'Go to Seats Chart',
  },
  event_type: 'Event Type',
  event_types: {
    'trance-party': 'Trance Party',
    'techno-party': 'Techno Party',
    'electronic-party': 'Electronic Party',
    'culture': 'Culture',
    'sport': 'Sport',
    'business': 'Business',
    'lecturer': 'Lecturer',
    'education': 'Education',
    'charity': 'Charity',
    'other': 'Other',
    'wellness': 'Wellness',
    'music': 'Music'
  },
  onboarding: {
    steps: {
      user_details: 'User details',
      account_details: 'Account details',
    },
  },
  forms: {
    validation: {
      numbers_only: 'Numbers only',
      invalid_phone: 'Invalid phone number',
    },
    fields: {
      birth_date: 'Birth date',
      gov_id: 'ID',
      logo_url: 'Logo URL',
      favicon_url: 'Favicon URL',
      main_domain: 'Main domain',
      distribution_id: 'Distribution ID',
    },
    features: {
      add_crm: 'Add CRM',
      add_producers_management: 'Add producers management',
      add_subscriptions_management: 'Add subscriptions management',
    },
    actions: {
      continue: 'Continue',
    },
  },
  ticket: {
    row: 'Row',
    seat: 'Seat',
    row_label: 'Row - {{row}}',
    seat_label: 'Seat - {{seat}}',
    ticket_number: 'Ticket #',
    order_number: 'Order Number',
    id_required: '(ID must be presented with the ticket)',
    ticket_name: 'Ticket Name',
    name: 'Name',
    event_date: 'Event Date',
    time: 'Time',
    appointment_time: 'Appointment Time',
    hall: 'Hall',
    ticket_type: 'Ticket Type',
    event_location: 'Event Location',
    notes: 'Notes',
    contact_email: 'Contact Event Manager',
    free_ticket: 'Free Ticket',
    price: 'Price',
    tickets: 'Tickets',
    ticket_refunded: 'This ticket was refunded',
    add_to_apple_wallet: 'Add to Apple Wallet',
    add_to_google_wallet: 'Add to Google Wallet',
    wallet_error: 'Failed to generate wallet pass',
    wallet_design_section_title: 'Wallet Pass Design',
    wallet_design_logo_label: 'Pass Logo',
    wallet_design_strip_label: 'Banner Image',
    wallet_design_bg_color_label: 'Background Color',
    wallet_design_fg_color_label: 'Text Color (Apple only)',
    wallet_design_label_color_label: 'Label Color (Apple only)',
    wallet_design_layout_label: 'Pass Layout (Apple only)',
    wallet_design_layout_reset: 'Reset to default',
    wallet_design_enabled_label: 'Enable wallet passes',
    wallet_design_marketplace_disabled: 'Wallet passes are disabled by the marketplace',
    wallet_design_row_secondary_label: 'Secondary',
    wallet_design_row_secondary_tooltip: 'The main visible area on the front of the pass. Shown directly below the banner image.',
    wallet_design_row_auxiliary_label: 'Auxiliary',
    wallet_design_row_back_label: 'Back of pass',
    wallet_design_row_auxiliary_tooltip: 'A secondary row below the main area. Good for extra details like ticket type, seat, and date.',
    wallet_design_row_back_tooltip: 'Shown on the back of the pass when the user taps the info (ⓘ) button. Use it for less important info like the order number.',
    wallet_design_preview_back_label: 'Back of pass',
    wallet_design_preview_title: 'Pass Preview',
    wallet_design_apple_tab: 'Apple Wallet',
    wallet_design_google_tab: 'Google Wallet',
    wallet_design_apple_only_tooltip: 'This setting only applies to Apple Wallet. Google Wallet automatically determines text color for contrast.',
    wallet_design_logo_helper: 'PNG, JPEG, or WebP only (SVG is not supported by Apple Wallet). Recommended: 160×50 px.',
    wallet_design_strip_helper: 'PNG, JPEG, or WebP. Recommended: 1125×432 px.',
    wallet_design_url_invalid: 'Must be a valid HTTPS URL (PNG, JPEG, or WebP)',
    wallet_design_color_invalid: 'Must be a valid hex color (e.g. #3c4150)',
    wallet_design_apple_only_label: 'only',
    wallet_design_preview_marketplace_name: 'Marketplace Name',
    wallet_design_preview_banner_placeholder: 'Banner Image',
    wallet_design_preview_hero_placeholder: 'Hero Image',
    wallet_design_field_event: 'EVENT',
    wallet_design_field_attendee: 'ATTENDEE',
    wallet_design_field_date: 'DATE',
    wallet_design_field_ticket_type: 'TICKET',
    wallet_design_field_seat: 'SEAT',
    wallet_design_field_order_number: 'ORDER',
    wallet_design_invalid_field_key: 'Invalid field key',
    wallet_design_invalid_row: 'Invalid row',
    wallet_design_invalid_position: 'Position must be a non-negative integer',
    wallet_design_unique_keys_error: 'Each field key must appear only once',
    wallet_preview_sample_event: 'Summer Festival',
    wallet_preview_sample_attendee: 'John Doe',
    wallet_preview_sample_ticket_type: 'General Admission',
    wallet_design_field_member_name: 'MEMBER',
    wallet_preview_sample_member_name: 'John Doe',
    wallet_design_tab_event: 'Event Pass',
    wallet_design_tab_membership: 'Membership Card',
    wallet_design_marketplace_name_label: 'Marketplace Name on Pass',
    wallet_design_marketplace_name_helper: 'Shown on the membership wallet pass. Defaults to your marketplace name.',
    wallet_design_marketplace_name_required: 'Marketplace name is required',
    wallet_design_marketplace_name_min: 'Marketplace name must be at least 3 characters',
  },
  event_seats: {
    bar: 'Bar',
    table: 'Table',
    row: 'Row',
    seat_label: 'Seat {{seat}}',
    parent_label: '{{type}} {{number}}',
    no_tickets: 'No tickets for sale',
    ticket_prices: 'Ticket Prices',
    coupon_note: 'Coupon code can be entered after selecting seats'
  },
  legal: {
    text: 'Text',
    default_policy: 'The system will display the default policy',
    hide_policy: 'The system will hide the privacy policy link',
    hide_privacy_policy: 'The system will hide the privacy policy link'
  },
  event_form: {
    short_url: 'Short URL',
    image_size_ideal: 'Ideal size - width {width} and height {height}',
    event_with_seats: 'Event with marked seats',
    ticket_price_min: 'Ticket price must be above ',
    count_tickets_min: 'Must be above 0',
    seats_prices_note: 'If this option is selected, ticket prices will be editable in the "Seat Chart" page',
    wellness_event: 'Wellness Event',
    wellness_event_note: 'Select this option if the event includes a trainer',
    trainer: 'Trainer',
    members_only_event: 'Members Only Event',
    members_only_event_note: 'If this option is selected, only club members will be able to purchase tickets for the event',
    collect_buyer_details: 'Collect separate buyer details for invoice',
    collect_buyer_details_helper: 'For events where the buyer differs from the attendee (e.g., kids\' camps) — the invoice/receipt is issued to the buyer rather than the first attendee',
    field_locked_after_orders: 'This field cannot be changed after orders have been made',
    buyer_pays_fee: 'Purchase fee will be paid by the ticket buyer',
    option_disabled_for_seats_event: 'This option cannot be selected for an event with marked seats',
    save: 'Save',
    no_edit_access: 'No access to edit the event',
    form_validation_error: 'Form is invalid, please check the fields',
    price_label: 'Price',
    min_price_error: 'At least 5 shekels',
    max_installments: 'Max installments',
    max_installments_note: 'Max installments buyers can split their payment into (PayMe only, 1 = disabled)',
  },
  membership_club: {
    payment_system: {
      title: 'Payment System',
      description: 'Advanced payment system for your club'
    },
    messaging_system: {
      title: 'Messaging System',
      description: 'Efficient communication with members'
    },
    event_management: {
      title: 'Event Management',
      description: 'Complete event management solution'
    },
    access_control: {
      title: 'Access Control',
      description: 'Secure access control system'
    },
    we_understand: 'We understand',
    similar_to_customers: 'Similar to our customers',
    wasting_time: 'Wasting time',
    competitive_world: 'Competitive world',
    vision: {
      title: 'Our Vision',
      subtitle: 'Transforming club management',
      solution: 'Complete solution',
      growth: 'Growth focused'
    },
    testimonials: {
      advanced_solution: 'Advanced solution',
      management_system: 'Management system',
      discover: 'Discover more',
      contact: 'Contact us',
      website: {
        title: 'Website',
        subtitle: 'Professional website',
        features: 'Key features'
      },
      management: {
        title: 'Management',
        subtitle: 'Efficient management',
        features: 'Key features'
      },
      finance: {
        title: 'Finance',
        subtitle: 'Financial management',
        features: 'Key features'
      },
      marketing: {
        title: 'Marketing',
        subtitle: 'Marketing tools',
        features: 'Key features'
      }
    }
  },
  success_stories: {
    title_prefix: 'Success Stories',
    our_clients: 'Our Clients',
    to_website: 'Visit website',
    clients: {
      zoa: {
        name: 'ZOA',
        role: 'Client'
      },
      radical: {
        name: 'Radical',
        role: 'Client'
      },
      camel: {
        name: 'Camel',
        role: 'Client'
      }
    }
  },
  scanner: {
    start_scanning: 'Start scanning',
    allow_camera_access: 'Allow camera access',
    scan_success: 'Scan successful',
    continue_scanning: 'Continue scanning',
    attention: 'Attention',
    try_again: 'Try again',
    error: 'Error',
    server_error: 'There is a technical issue, try refreshing the page try again',
    server_error_description: 'There is a technical issue, try refreshing the page and try again',
    select_camera: 'Select camera',
    session_title: 'Multi-Event Scanner',
    covered_events: 'Covered Events',
    event_not_in_session: 'This event is not covered by this scanner',
    ticket_for_event: 'Ticket for: {{eventName}}',
    basket_order_title: 'Basket Order',
    basket_check_in: 'Check In Selected',
    basket_cancel: 'Cancel',
    basket_not_covered: 'Not covered by this scanner',
    basket_all_success: 'All check-ins successful',
    basket_partial_success: '{{success}} of {{total}} events checked in',
    basket_event_success: 'Checked in successfully',
    basket_event_failed: 'Check-in failed',
    no_events_selected: 'No events selected for check-in',
    basket_results_title: 'Check-in Results',
    basket_customer: 'Customer',
    basket_order_number: 'Order #{{number}}',
    basket_order: 'Basket Order',
    not_covered: 'Not covered',
    check_in_selected: 'Check In Selected',
    cancel: 'Cancel',
    check_in_results: 'Check-in Results',
    external_scanner: 'External Scanner',
    camera_scanner: 'Camera',
    external_scanner_ready: 'Ready to scan — press the scanner button',
    external_scanner_firefox_note: 'For best results, use Firefox browser',
    subscription_checked_in: 'Subscription checked in',
    family_check_in: 'Family Check-In',
    select_family_members: 'Select family members to check in',
    member_inactive: 'Inactive',
    member_incomplete: 'Profile incomplete',
    invalid_subscription_qr_format: 'Invalid subscription QR code format',
    invalid_qr_format: 'Invalid QR code format',
    ticket_not_in_session: 'This ticket belongs to {{eventName}} which is not covered by this scanner',
    check_in_success: 'Check-in successful',
    subscription_already_checked_in: 'Already checked in today',
    same_day_rescan: 'Already checked in today',
    subscription_scan_number: 'Scan #{{number}}',
    checked_in: 'Checked in',
    just_now: 'Just now',
    seconds_ago: '{{count}}s ago',
    a_minute_ago: 'A minute ago',
    minutes_ago: '{{count}} min ago',
    hours_ago: '{{count}}h ago',
    hours_and_minutes_ago: '{{hours}}h {{minutes}}m ago',
  },
  sub_accounts: {
    my_productions: 'My productions',
    create_production: 'Create production',
    no_productions: 'No productions',
    handler_exists: 'Handler already exists',
    handler_description: 'Handler description',
    name: 'Name',
    short_url: 'Short URL',
    submit: 'Submit',
    edit: 'Edit',
    edit_production: 'Edit production',
    attention: 'Attention',
    links_will_change: 'Links will change',
    my_sellers_productions: 'My sellers productions',
    search_production: 'Search production',
    find_events_and_productions: 'Search events, productions or order number...',
    productions: 'Productions',
    no_results_found: 'No results found',
    events_search_results: 'Events ({{total}} total, showing {{showing}})',
    order_search_result: 'Order result'
  },
  settings: {
    max_capacity: {
      title: 'Max capacity',
      example: 'Example',
      explanation: 'Explanation'
    },
    event_link: 'Event link',
    qr_code: 'QR Code',
    qr_code_title: 'Event QR Code',
    qr_code_description: 'Scan or share this QR code to access the event page',
    download_qr: 'Download',
    share_qr: 'Share',
    show_in_seller_page: "Show in <customLink>seller page</customLink>",
    show_in_seller_page_plain: "Show in seller page",
    waiting_list: 'Waiting list',
    allow_coupons: 'Allow coupons',
    seats_event_tooltip: 'Seats event tooltip',
    min_capacity_error: 'Min capacity error',
    max_capacity_error: 'Max capacity error',
    one_user_form: 'One user form',
    only_for_members: 'Only for members',
    allow_season_ticket: 'Allow season ticket',
    show_seller_header: 'Show seller header',
    is_bookable: 'Event is bookable for subscribers only',
    is_bookable_helper: 'subscribers can reserve their spot without going through the ticket purchase page and non subscribers will be asked to purchase a subscription',
    is_bookable_with_tickets: 'Event is bookable with tickets',
    is_bookable_with_tickets_helper: 'Event is bookable for subscribers but they can also purchase multiple tickets, for non subscribers they will be redirected to the event page to purchase a ticket',
    what_is_seller_page: 'What is the seller page?',
    seller_page_explanation: 'The seller page is designed for you to sell more events, by displaying all your productions and events in one place, you can also sell monthly subscriptions, entry-passes, and much more. You can use it to establish a community of loyal customers.',
    seller_page_settings: 'Seller page settings',
    allow_split_payment: 'Allow split payment',
    allow_members_one_ticket_only: 'limit members to one order per event',
    enable_external_scanner: 'Enable external infrared scanner',
    max_capacity_switch: 'Max capacity switch',
    max_tickets: 'Max tickets',
    no_edit_access: 'No edit access',
    seller_page_behavior: 'Seller page behavior',
    scanner_sessions: 'Scanner Sessions',
    scanner_sessions_description: 'Create scanner sessions that cover multiple events. Share the scanner URL with your staff at the entrance.',
    add_scanner_session: 'Add Scanner Session',
    edit_scanner_session: 'Edit Scanner Session',
    session_name: 'Session Name',
    scanner_session_name: 'Session Name',
    scanner_session_name_required: 'Session name is required',
    session_events: 'Events',
    scanner_session_events: 'Events',
    scanner_session_season_tickets: 'Season Tickets',
    scanner_url: 'Scanner URL',
    copy_scanner_url: 'URL Copied',
    show_scanner_qr: 'Show QR code',
    scanner_qr_title: 'Scanner Session QR Code',
    scanner_qr_description: 'Scan this QR code with a phone camera to open the scanner on the device.',
    delete_session: 'Delete Session',
    delete_session_confirm: 'Are you sure you want to delete this scanner session?',
    no_scanner_sessions: 'No scanner sessions configured yet',
    session_created: 'Scanner session created',
    session_updated: 'Scanner session updated',
    session_deleted: 'Scanner session deleted',
    scanner_session_saved: 'Scanner session saved',
    scanner_session_auto_exit: 'Auto Exit',
    scanner_session_auto_exit_description: 'Automatically stamps an exit visit on every scan'
  },
  form_fields: {
    translation_support_note: 'Note: Only the following field labels support translation:',
    supported_fields: 'Supported fields',
    birthday: {
      label: 'Birthday',
      title: 'Birthday',
      day: 'Day',
      month: 'Month',
      year: 'Year',
    },
    first_name: {
      label: 'First name',
      title: 'First name'
    },
    last_name: {
      label: 'Last name',
      title: 'Last name'
    },
    email: {
      label: 'Email',
      title: 'Email'
    },
    phone: {
      label: 'Phone',
      title: 'Phone',
      settings_info: 'When enabled, every ticket holder must provide their own phone number. When disabled, only the first ticket holder provides a phone number — it is used for payment processing and shared across the order.',
      cant_hide: 'Phone cannot be hidden — at least one phone number is always required to process the payment.'
    },
    gender: {
      label: 'Gender',
      title: 'Gender'
    },
    social_link: {
      label: 'Social Network Link',
      title: 'Social Network Link',
      allowed_networks: 'Allowed Social Networks',
      select_networks: 'Select social networks',
      validation_error_label: 'Custom Error Message',
      validation_error_default: 'Please provide a valid social network link',
      link_required: 'link required',
      links_required: 'links required',
      or: 'OR'
    },
    email_marketing: {
      label: 'Marketing Email Consent',
      title: 'Marketing Email Consent'
    },
    example: {
      title: 'Order Details - Example',
      label: 'Order Details - Example'
    },
    required: 'Required',
    hide: 'Hide',
    field_title: 'Field title',
    cant_hide_required: 'Cannot hide required field',
    business_code: {
      label: 'Business Number (Company ID)',
      title: 'Business Number (Company ID)'
    },
    business_name: {
      label: 'Business Name',
      title: 'Business Name'
    },
  },
  links: {
    table: {
      name: 'Name',
      description: 'Description',
      utm: 'Link',
      createdAt: 'Creation Date',
      tickets: 'Tickets',
      isActive: 'Status',
      sessions: 'Sessions',
      usersViews: 'Users',
      sold_count: 'Tickets Sold',
      refund_count: 'Tickets Refunded',
      cancel_count: 'Tickets Cancelled',
      pending_count: 'Tickets Pending Approval'
    },
    form: {
      name: 'Name',
      description: 'Description',
      ticketsPerPurchase: 'Tickets per purchase',
      ticketsPerPurchaseHelper: 'Number of tickets available for purchase with this link',
      amountToCreate: 'Number of links to create',
      isActive: 'Active',
      tickets: 'Tickets',
      ticketsHelper: 'Tickets to display on page',
      noCollaborator: 'No collaborator assigned',
      noCollaboratorsHelper: 'You can invite collaborators and track their marketing performance',
      clickToInviteMarketers: 'Click here to invite marketers'
    },
    primary: 'Primary',
    heading: 'Links',
    view_details: 'View Details',
    dialog: {
      update_title: 'Update Link',
      create_title: 'Create Link',
      update_button: 'Update Link',
      create_button: 'Create Link'
    }
  },
  search_advanced: 'Advanced Search',
  search_users_in_segments: 'Search users in these segments',
  price: 'Price',
  status: 'Status',
  table: {
    type: 'Type',
    name: 'Name',
    status: 'Status',
    action: 'Action',
    additional_data: 'Additional Data'
  },
  marketplace: {
    email_already_exists: 'Email already exists',
    handler_already_exists: 'Short URL already exists in the system',
    market_fee_minimum: 'Commission amount must be above - {{0}}%',
    form: {
      password: 'Password',
      seller_name: 'Seller name',
      phone: 'Phone',
      gov_id: 'ID number',
      market_fee: 'Processing fee',
      market_fee_helper: '(Processing fee including VAT)',
      market_fee_min_amount: 'Minimum amount - {{0}}%',
      add: 'Add'
    },
    sellers: {
      no_approved_sellers: 'No approved sellers',
      pending_approval: 'Pending approval',
      my_sellers: 'My Sellers - {{0}}',
      add_new_seller: 'Add new seller',
      no_sellers: 'No sellers',
      status: {
        active: 'Active',
        created: 'Created',
        unknown: '---'
      },
      details: {
        email: 'Email - ',
        phone: 'Phone',
        registration_date: 'Registration Date',
        market_fee: 'Processing fee - ',
        terminal_setup: 'Terminal setup arrangement',
        use_existing_terminal: 'I want to use my terminal for this account - money will be transferred to my bank account',
        create_new_terminal: 'I want to open a new terminal account and money will be transferred to the new bank account'
      },
      approve_seller: 'Approve Seller',
      approved_successfully: 'Seller approved successfully',
      edit: 'Edit',
      edit_seller: 'Edit Seller',
      name: 'Name',
      name_placeholder: 'Enter seller name',
      email: 'Email',
      email_placeholder: 'Enter seller email',
      market_fee: 'Market Fee (%)',
      market_fee_placeholder: 'Enter market fee percentage',
      market_fee_min: 'Market fee must be at least 0%',
      market_fee_max: 'Market fee cannot exceed 100%',
      save_changes: 'Save Changes',
      search_placeholder: 'Search sellers by name...',
      no_search_results: 'No sellers found',
      no_search_results_description: 'No sellers found matching "{{query}}"'
    }
  },
  private_club: {
    visitor_count: 'Visitor count',
    member_returned: 'Member returned?',
    member_left: 'Member left?',
    update_visitor_count: 'Update visitor count',
    all_left: 'All left',
    enter: 'Enter',
    select_visitor: 'Visitors',
    active: 'Active',
    exited: 'Exited',
    visits_report: 'Visits Report'
  },
  visits_timeline: {
    title: 'Visits Timeline Report',
    total_visits: 'Total Visits',
    total_guests: 'Total Guests',
    avg_guests: 'Avg Guests/Visit',
    avg_duration: 'Avg Duration',
    filters: 'Filters',
    start_date: 'Start Date',
    end_date: 'End Date',
    select_member: 'Select Member',
    all_members: 'All Members',
    apply: 'Apply',
    clear: 'Clear',
    today: 'Today',
    yesterday: 'Yesterday',
    last_7_days: 'Last 7 Days',
    last_30_days: 'Last 30 Days',
    last_90_days: 'Last 90 Days',
    visit_history: 'Visit History',
    no_visits_found: 'No visits found for the selected filters',
    date: 'Date',
    member: 'Member',
    guests: 'Guests',
    entry_time: 'Entry Time',
    exit_time: 'Exit Time',
    duration: 'Duration',
    status: 'Status',
    visits: 'Visits',
    daily_visits: 'Daily Visits Trend',
    daily_visits_subtitle: 'Number of visits and guests per day',
    hourly_visits: 'Peak Hours Analysis',
    hourly_visits_subtitle: 'Visit distribution throughout the day'
  },
  export_data_dialog: {
    header: {
      index: '#',
      order_number: 'Order Number',
      order_status: 'Order Status',
      order_date: 'Order Date',
      first_name: 'First Name',
      last_name: 'Last Name',
      gender: 'Gender',
      birth_date: 'Birth Date',
      phone: 'Phone',
      phone_excel: 'Phone (Excel)',
      email: 'Email',
      ticket_name: 'Ticket Name',
      original_price: 'Original Price',
      price_after_discount: 'Price After Discount',
      refund: 'Refund',
      coupon_name: 'Coupon Name',
      subscription: 'Subscription',
      late_order: 'Late Order',
      scanned: 'Scanned'
    },
    order_status: {
      pending: 'Pending',
      rejected: 'Rejected',
      paid: 'Paid',
      full_refund: 'Full Refund',
      partial_refund: 'Partial Refund',
      unknown: '-'
    },
    download_data: 'Download Data',
    download: 'Download',
    all_orders: 'All Orders',
    approved_orders: 'Approved Orders',
    rejected_orders: 'Rejected Orders',
    pending_orders: 'Pending Orders',
    refunded_orders: 'Refunded Orders',
    file_name: 'Event Orders.csv'
  },
  whitelist_dialog: {
    approved_entry: 'Approved Entry',
    set_approved_entry: 'Set Approved Entry',
    segments_description: 'Customers belonging to selected segments will be defined as approved for entry to the event',
    select_segments: 'Select Segments',
    approved_entry_will_get: 'Approved entry will get',
    table_mark_only: 'Table mark only',
    auto_approval: 'Auto approval',
    save: 'Save',
    saved_successfully: 'Saved successfully',
    save_failed: 'Save failed',
    loading: "Loading...",
    approve_if_any_in_segment: 'Approve/mark if any ticket holder is in segment'
  },
  user_event_form: {
    order_status: 'Order Status',
    approved: 'Approved'
  },
  refund_dialog: {
    money_already_transferred: 'Sorry, refunds cannot be processed for orders in this event as the money has already been transferred to your account',
    refund_amount: 'Refund Amount',
    refund_amount_error: 'Refund amount is greater than the maximum amount',
    refund_tickets: 'Refund Tickets',
    refund_all_tickets: 'Refund All Tickets',
    ticket_name: 'Ticket Name',
    ticket_price: 'Price',
    refund_fee: 'Refund Fee',
    refund_fee_info: 'A refund fee of {{0}}% will be deducted from the refund amount',
    buyer_paid_fee: 'Fee amount (paid by buyer) - {{amount}}',
    refund: 'Refund',
    cancel: 'Cancel',
    refund_amount_label: 'Choose refund amount',
    refund_amount_helper: 'Refund amount cannot exceed order amount',
    order_amount: 'Order amount',
    already_refunded_amount: 'Order has already been refunded amount',
    tickets_return_caption: 'The marked tickets will be returned to the ticket pool for sale',
    ticket_refunded: 'Refunded',
  },
  inner_row: {
    approved: 'Approved',
    not_approved: 'Not Approved',
    refunded: 'Refunded',
    scanned: 'Scanned',
    not_scanned: 'Not Scanned',
    free_ticket: 'Free Ticket',
    cannot_scan_unapproved: 'Cannot scan unapproved buyer',
    seat_label: 'Seat: {{0}}'
  },
  table_columns: {
    subscription: 'Subscription'
  },
  event_order_table: {
    whitelist_tooltip: 'Appears in the approved entry list',
    late_order: 'Late Order',
    free: 'Free'
  },
  transformers: {
    yes: 'Yes',
    no: 'No',
    hrc_errors: {
      subscription_already_used: 'Subscription already used',
      subscription_not_active: 'Subscription found but not active or exceeded quota',
      no_entries_left_for_event: 'No entries left for this event',
      no_entries_left: 'No entries left',
      not_configured_for_event: 'Subscription not configured for this event',
      subscription_not_found: 'Subscription not found',
      end_user_season_ticket_not_found: 'season ticket not found'
    },
    order_number_prefix: 'Order number'
  },
  seatsIo: {
    table: 'Table',
    row: 'Row',
    seat: 'Seat'
  },
  payment: {
    technical_error: 'There is a technical issue, try refreshing the page and we will try again. The issue should resolve itself',
    total: 'Total',
    card_number: 'Card number',
    expiration: 'Expiration',
    cvv: 'CVV',
    first_name: 'First name',
    last_name: 'Last name',
    social_id: 'Social ID',
    pay_now: 'Pay now',
    initializing: 'Initializing payment...',
    initialization_error: 'Failed to initialize payment',
    initialization_failed: 'Payment initialization failed',
    configuration_required: 'Payment Configuration Required',
    no_provider_configured: 'No payment provider configured',
    waiting_initialization: 'Waiting for payment initialization...',
    stripe_init_failed: 'Failed to initialize Stripe. Please try again.',
    stripe_not_enabled: 'Stripe payments are not enabled. Please contact the seller.',
    stripe_account_not_connected: 'Stripe account not connected. Please complete Stripe setup to accept payments.',
    stripe_account_id_missing: 'Stripe account ID is missing',
    stripe_charges_not_enabled: 'Stripe charges are not enabled',
    stripe_currency_not_configured: 'Stripe currency is not configured',
    payme_not_configured: 'PayMe is not configured. Please configure PayMe or select a different payment provider.',
    payme_public_key_missing: 'PayMe public key is missing',
    retry: 'Try Again'
  },
  warnings: {
    attention: 'Attention',
    no_tickets_defined: 'No tickets have been defined for this event yet',
    define_tickets: 'Define tickets'
  },
  date_operator: {
    between: 'Between',
    from_date: 'From date',
    to_date: 'To date'
  },
  footer: {
    sections: {
      services: 'Services',
      links: 'Links',
      terms: 'Terms',
      contact: 'Contact'
    },
    links: {
      club_management: 'Club Management',
      scanner_apple: 'Ticket Scanner Apple App Store',
      scanner_google: 'Ticket Scanner Google Play Store',
      privacy_policy: 'Privacy Policy',
      terms_of_service: 'Terms of Service',
      talk_to_us: 'Talk to us',
      address: 'Address',
      address_text: 'mind-space Ramat Gan'
    }
  },
  directions: 'Directions',
  required_field: 'Required field',
  no_access: 'No access',
  hello: 'Hello',
  world: 'World',
  continue: 'Continue',
  wellness_event: 'Wellness event',
  promoter: {
    sales_funnel_bottom_line: 'Total sales',
    link_details: 'Link details',
    my_links: 'My Links',
    sales_funnel: 'Sales Funnel',
    funnel: {
      views: 'Views',
      unique_visitors: 'Unique Visitors',
    }
  },
  book_event: {
    book_now: 'Book a spot now',
    goto_tickets: 'Select tickets',
    success: 'Successfully Registered!',
    success_message: 'You have been successfully registered for this event!',
    close: 'Close',
    you_are_not_logged_in: 'You are not logged in',
    login_required: 'Login Required',
    login_required_title: 'You need to be logged in',
    login_required_message: 'In order to book this event, you need to be logged in to your account.',
    subscription_required: 'Subscription Required',
    subscription_required_title: 'You need a subscription',
    subscription_required_message: 'In order to book this event, you need to purchase a subscription plan.',
    subscription_manual_only_message: 'Subscriptions for this seller are only available through direct contact. Please contact the seller to purchase a subscription.',
    purchase_subscription: 'Purchase Subscription',
    subscription_already_used_for_event: 'Your subscription has already been used for this event',
    subscription_not_active_or_limit_reached: 'Your subscription is not active or has reached its limit',
    subscription_event_limit_reached: 'You have reached the maximum number of free entries for this event',
    subscription_overall_limit_reached: 'You have reached the overall limit of your subscription',
    subscription_not_configured_for_event: 'Your subscription is not configured for this type of event',
    no_active_subscription: 'No active subscription found',
    cannot_book_for_free: 'This event cannot be booked for free with your current subscription',
    sold_out: 'Tickets are sold out',
    booking_failed: 'Booking failed. Please try again later.',
    time_slot_required: 'Please select a time slot before booking',
  },
  common: {
    cancel: 'Cancel',
    login: 'Login',
    error_loading_account: 'Error loading account information. Please try again.',
    missing_required_data: 'Missing required data',
  },
  feature_intro: {
    welcome: 'Welcome to this feature!',
    default_description: 'Discover what this feature can do for you',
    key_features: 'Key Features',
    got_it: 'Got it!',
    learn_more: 'Learn More',
    show_intro: 'Show Feature Introduction',
    customer_club: {
      title: 'Customer Club - Two Powerful Membership Types',
      description: 'Customer Club helps you build stronger relationships with your customers through membership programs. Create exclusive offers, track member engagement, and reward your most loyal customers with special benefits.',
      main_description: 'Customer Club offers TWO distinct membership types to serve different customer needs. Choose between recurring Subscriptions (like monthly gym memberships) or one-time Entry Passes (like punch cards). Both can be configured with special pricing for each event!',
      subscription_title: '1. SUBSCRIPTIONS - Recurring Memberships',
      subscription_description: 'Like a monthly gym or class membership (חוג). Customers pay automatically every day/week/month/year. Perfect for regular attendees who want ongoing access to your events. Members can get FREE entry or special discounts.',
      entry_pass_title: '2. ENTRY PASSES - Prepaid Punch Cards',
      entry_pass_description: 'One-time purchase that gives customers a set number of entries (like a 10-class yoga card). Each event "punches" their card. Great for customers who want flexibility without monthly commitment.',
      redemption_title: 'How Members Redeem Their Benefits',
      redemption_description: 'Members have TWO easy ways to use their membership or entry pass: 1) Login with their phone number on the event page, or 2) Use the unique redemption code sent to their email after purchase. Simple and secure!',
      how_members_redeem_title: 'How Your Members Use Their Membership',
      redemption_alert: 'Members receive automatic confirmation email with their unique redemption code after purchase',
      method1_title: 'Method 1: Phone Number Login',
      method1_description: 'Members simply enter their phone number on the event booking page. The system automatically recognizes their membership and applies the discount or free entry.',
      method2_title: 'Method 2: Email Redemption Code',
      method2_description: 'After purchase, members receive an email with a unique redemption code. They can enter this code during checkout to apply their membership benefits.',
      screenshot_caption: 'Example: How members see the redemption process',
      screenshot_placeholder_text: 'Screenshot will be displayed here when provided',
      automatic_discount_title: 'Automatic Discount at Checkout',
      automatic_discount_description: 'When club members purchase tickets for events, the discount is automatically applied at checkout',
      no_code_needed: 'No need to enter a code or take any additional action - the system recognizes membership and applies the discount instantly',
      checkout_screenshot_caption: 'Example of checkout page with member discount',
      checkout_image_placeholder: 'Checkout page image with automatic discount will appear here',
      event_pricing_title: 'Flexible Event Pricing Control',
      event_pricing_description: 'In each event\'s settings, YOU decide what discount each subscription or entry pass provides. Set it to FREE (100% off), 40% off, or any discount you choose. Different events can have different benefits!',
      business_benefits_title: 'Why Use Customer Club?',
      business_benefits_description: 'Predictable recurring revenue from subscriptions, increased customer loyalty, advance sales through entry passes, and automated payment collection. Your customers save money while you build a stable business!',
      feature1_title: 'Member Management',
      feature1_description: 'Easily manage your club members, track their activity, and understand their preferences',
      feature2_title: 'Exclusive Discounts',
      feature2_description: 'Create special discount codes and offers exclusively for your club members',
      feature3_title: 'Analytics & Insights',
      feature3_description: 'Get detailed analytics about member behavior, purchase patterns, and engagement levels',
      feature4_title: 'Event Access',
      feature4_description: 'Grant special access to events, early bird tickets, or VIP experiences for your members',
    },
    subscription_form: {
      title: 'Understanding Subscriptions',
      description: 'Subscriptions are recurring membership plans that provide ongoing benefits to your customers. Perfect for regular attendees who want unlimited or discounted access to your events.',
      feature1_title: 'Recurring Payments',
      feature1_description: 'Set up daily, weekly, monthly, or yearly payment cycles. Customers are automatically charged based on your selected frequency.',
      feature2_title: 'Event Limit Control',
      feature2_description: 'Define how many events a subscriber can attend. Set to 0 for unlimited access, or specify a maximum number of events.',
      feature3_title: 'Public Visibility',
      feature3_description: 'Choose whether to display this subscription on your public seller page for customers to purchase directly.',
    },
    entry_pass_form: {
      title: 'Understanding Entry Passes',
      description: 'Entry passes are pre-paid ticket bundles that give customers a fixed number of entries to use across your events. Perfect for flexibility without commitment.',
      feature1_title: 'Punch Card System',
      feature1_description: 'Set a total number of entries (punches) that customers can use. Each event attendance uses one or more punches.',
      feature2_title: 'Event Entry Limits',
      feature2_description: 'Control how many entries can be used per event. Leave empty for unlimited entries per event (until total is reached).',
      feature3_title: 'One-Time Purchase',
      feature3_description: 'Entry passes are purchased once and valid until all entries are used, unlike recurring subscriptions.',
    },
    my_members: {
      title: 'My Members - Your Complete Member Management Hub',
      description: 'View and manage all your customers with active subscriptions or entry passes in one powerful dashboard. Track engagement, add notes, monitor status, and export data for deeper analysis.',
      search_title: 'Smart Search & Filtering',
      search_description: 'Instantly find any member by searching names, phones, emails, or notes. Use advanced filters for subscription type, status, price range, and multiple date ranges.',
      status_title: 'Real-Time Status Tracking',
      status_description: 'Monitor which members are active or inactive with color-coded status labels. See at a glance who needs attention or re-engagement.',
      notes_title: 'Member Notes System',
      notes_description: 'Add custom notes to each member to track special requirements, preferences, or internal communication. Keep important information always accessible.',
      dates_title: 'Comprehensive Date Analytics',
      dates_description: 'Track join dates, cancellation dates, and last participation to understand member engagement patterns and identify trends.',
      export_title: 'Data Export & Reports',
      export_description: 'Export all member data to CSV format for analysis in Excel or other tools. Full UTF-8 support ensures Hebrew characters display correctly.',
      profile_title: 'Full Member Profiles',
      profile_description: 'Click any member to access their complete profile including full purchase history, event participation, and detailed subscription information.',
    },
    legal_settings: {
      title: 'Legal Settings - Manage Your Privacy Policy and Terms',
      description: 'Configure your marketplace\'s legal documents including Privacy Policy, Terms of Service, and Club Membership Terms. Choose between default templates, custom links, or upload your own PDF documents to ensure compliance with local regulations.',
      privacy_title: 'Privacy Policy Configuration',
      privacy_description: 'Set up how your Privacy Policy is displayed to customers. Use our default template, link to your own policy, upload a PDF, or hide it if not required.',
      terms_title: 'Terms of Service Management',
      terms_description: 'Define your Terms of Service that customers must accept. This is required and cannot be hidden - choose between default, custom link, or PDF upload.',
      membership_title: 'Club Membership Terms',
      membership_description: 'Specific terms for subscription and entry pass holders. Configure separately from general terms to provide clear membership conditions.',
      flexibility_title: 'Flexible Display Options',
      flexibility_description: 'Four ways to display each document: Use default templates, link to external URLs, upload PDF files, or hide (where allowed).',
      compliance_title: 'Legal Compliance Made Easy',
      compliance_description: 'Ensure your business meets legal requirements with properly configured terms and policies that protect both you and your customers.',
      how_it_works_title: 'How Legal Document Options Work',
      important_note: 'Legal documents appear during checkout and registration. Customers must accept terms before completing purchases.',
      options_title: 'Available Options for Each Document:',
      option_default: 'Use system-provided template (professionally written, covers standard requirements)',
      option_link: 'Link to your external legal document URL (hosted on your website)',
      option_pdf: 'Upload your custom PDF document (stored securely, displayed to customers)',
      option_hide: 'Hide this document (only available for privacy policy and membership terms)',
      screenshot_caption: 'Example: How legal documents appear to your customers',
      screenshot_placeholder: 'Legal settings screenshot will be displayed here when provided',
    },
    my_leads: {
      title: 'Lead Management System',
      description: 'Manage your potential members from initial interest through approval and subscription purchase. Track leads from manual entry or website webhooks, schedule meetings, and convert them into active members.',
      manual_title: 'Manual Lead Creation',
      manual_description: 'Add leads manually with their contact information, interests, and notes. Perfect for walk-ins or phone inquiries.',
      webhook_title: 'Website Integration',
      webhook_description: 'Automatically capture leads from your website when visitors express interest in becoming members. No data entry required!',
      schedule_title: 'Calendar Scheduling',
      schedule_description: 'Schedule meetings directly on your calendar to discuss membership options with potential members.',
      approval_title: 'Approval Workflow',
      approval_description: 'Review and approve leads to become members. Set their status, add notes, and track their progress.',
      subscription_title: 'Subscription Purchase',
      subscription_description: 'Once approved, members can purchase subscriptions directly through the system, completing the onboarding process.',
      tracking_title: 'Lead Analytics',
      tracking_description: 'Track conversion rates, follow-up status, and lead sources to optimize your member acquisition process.',
    },
    production: {
      title: 'Production Management - Organize Events Like a Pro',
      description: 'Productions are powerful folders that organize similar events together. They enable team collaboration, shared settings, and create beautiful, professional event URLs for your customers.',
      folder_organization_title: 'Smart Event Organization',
      folder_organization_description: 'Group related events (like weekly yoga classes, monthly workshops, or concert series) under one production for streamlined management.',
      collaboration_title: 'Team Collaboration Hub',
      collaboration_description: 'Invite team members and assign roles once - they automatically get the same permissions for ALL events in this production, current and future!',
      url_structure_title: 'Beautiful Event URLs',
      url_structure_description: 'Create professional, memorable links: your-domain.com/production-name/event-name. Perfect for marketing and easy customer access.',
      shared_settings_title: 'Configure Once, Apply to All',
      shared_settings_description: 'Set up integrations, buyer questions, and page behavior once for the production - all events inherit these settings automatically.',
      role_inheritance_title: 'Automatic Role Inheritance',
      role_inheritance_description: 'When you add a new event to the production, all collaborators instantly have access based on their assigned roles. No manual permissions needed!',
      centralized_management_title: 'Centralized Control Panel',
      centralized_management_description: 'Manage all production settings from one dashboard: general info, integrations, buyer questions, and seller page behavior.',
    },
    event_settings: {
      title: 'Event Configuration Features',
      description: 'Optimize your event setup with these powerful settings to enhance the buyer experience',
      seller_page_desc: 'When enabled, this event will be visible on your public seller page, allowing customers to discover and purchase tickets directly from your branded storefront.',
      one_form_desc: 'Simplify the checkout process! When buyers purchase multiple tickets, they only need to fill in their details once, making bulk purchases faster and easier.',
      season_ticket_desc: 'Enable season pass holders to use their special codes. An input field will appear during checkout for customers to apply their season ticket benefits.',
      coupons_desc: 'Boost sales with promotional codes! Customers can apply coupon codes during checkout to receive discounts and special offers.',
    },
  },
  member_club_intro: {
    title: 'Member Club Management Calendar',
    description: 'As an administrator, manage all member club events, track attendance, and organize activities from this centralized calendar view. Streamline your club operations and member registrations.',
    feature1_title: 'Member Registration Control',
    feature1_description: 'As an admin, register members for events directly from the calendar with the integrated member selection dropdown. Quickly assign members to classes and activities.',
    feature2_title: 'Event Administration',
    feature2_description: 'Create and manage different types of club events including regular classes, wellness sessions, and special member activities. Full control over scheduling and capacity.',
    feature3_title: 'Attendance Monitoring',
    feature3_description: 'Track member participation across all events with detailed progress indicators. View real-time capacity and registration status at a glance.',
    feature4_title: 'Season Ticket Management',
    feature4_description: 'Manage season ticket allocations and help members book their spots in upcoming events. Control member access and benefits from one central location.',
  },
  inactivity: {
    warning_title: 'Are you still there?',
    warning_message: 'You will be logged out soon due to inactivity for security reasons.',
    warning_hint: 'Click the button below to stay logged in, or continue working to reset the timer automatically.',
    stay_logged_in: 'Stay Logged In',
    logged_out_message: 'You were logged out due to inactivity for security reasons. Please log in again to continue.',
  },
  family: {
    manage_family: "Manage Family",
    manage_subscription: "Manage Subscription",
    family_members: "Family Members",
    adults: "Adults",
    children: "Children",
    parent: "Parent",
    adult: "Adult",
    child: "Child",
    child_age: "Child (age {{age}})",
    no_phone: "No phone",
    no_name: "No name",
    no_email: "No email",
    details_required: "Details Required",
    add_name_photo: "Complete missing details to activate",
    complete: "Completed",
    complete_action: "Complete",
    incomplete_warning: "{{count}} family member(s) need to complete their profile to activate their subscription",
    incomplete_badge: "{{count}} incomplete",
    managed_by: "Managed by {{name}}",
    season_ticket_family: "Season Ticket · Family",
    back_to_my_account: "Back to My Account",
    complete_profile: "Complete Profile",
    edit_member: "Edit Member",
    first_name: "First Name",
    last_name: "Last Name",
    date_of_birth: "Date of Birth",
    photo: "Photo",
    remove_photo: "Remove photo",
    phone: "Phone",
    id_or_passport: "ID / Passport",
    social_link: "Social Link",
    id: "ID",
    incomplete_profiles_title: "Complete missing details to activate this subscription",
    manage: "Manage",
    edit_my_details: "Edit my details",
    incomplete_member_label_unnamed: "Family member (details required)",
    photo_required: "Photo is required for activation",
    pricing_tiers: "Pricing Tiers",
    define_prices: "Define fixed prices for family compositions",
    add_tier: "Add Tier",
    children_min: "Children (min)",
    starting_from: "Starting from",
    see_pricing: "See Pricing",
    family_pricing: "Family Pricing",
    plan: "Plan",
    combination_not_available: "This combination is not available",
    pricing_not_configured: "Pricing not configured",
    duplicate_tier: "Duplicate adults/children combination",
    min_one_tier: "At least one pricing tier is required",
    family_plan: "Family Plan",
    go_to_manage_family: "Go to Manage Family",
    family_success_message: "Your family subscription has been created! Complete your family members' profiles to activate their subscriptions.",
    child_price: "Child Price",
    invalid_child_price: "Enter a valid child price",
    price_overridden: "Custom override",
    child_max_age: "Child Max Age",
    max_adults: "Max Adults",
    max_children: "Max Children",
    allow_family: "Allow Family Subscription",
    family_settings: "Family Settings",
    family_indicator: "Family · {{count}} members",
    phone_already_in_family: "This phone number is already linked to another family subscription",
    age_exceeds_limit: "Child's age exceeds the maximum age limit ({{maxAge}})",
    age_below_adult_min: "Adult's age must be above the maximum child age ({{maxAge}})",
    show_qr: "QR Code",
    scan_to_check_in: "Show this QR code at the entrance for check-in",
    required_fields: "Required Fields for Activation",
    you: "YOU",
    no_family_members: "No family members found",
    add_child: "Add Child",
    add_adult: "Add Adult",
    adult_price: "Adult Price",
    remove_member_confirm: "Are you sure you want to remove this member?",
    member_removed: "Family member removed",
    member_updated: "Family member updated",
    child_added: "Child added successfully",
    adult_added: "Adult added successfully",
  },
  subscription: {
    required_fields: 'Required fields',
    complete_profile_to_access_entrance: 'Please complete your profile to access the entrance code',
  },
  columns: "Columns",
};

export default en;
